import UserSearch from '../components/UserSearch';
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement,
} from 'chart.js';
import { Bar, Doughnut } from 'react-chartjs-2';
import {
  Users,
  BarChart3,
  Settings,
  Printer,
  FileText,
  Search,
  User,
  X,
  Eye,
  ChevronLeft,
  ChevronRight,
  Image,
  File,
  MessageCircle,
  UserCheck,
  ChevronDown,
  Download,
  Clock,
} from 'lucide-react';
import DashboardHeader from '../components/DashboardHeader';
import { fetchDepartments } from '../APIServices/DepartmentsServices';
import ResetPassword from '../components/AssignComplaint/ResetPassword';
import ScheduleReportPage from './ScheduleReportPage';
import dashboardService from '../services/dashboardService';
import InteractionMap from './InteractionMap';
import {
  addOfficer,
  getOfficers,
  deleteOfficer,
  editOfficer,
} from '../APIServices/adminOfficerService';
import { AdminService } from '../services';
import { fetchTalukas } from '../APIServices/LocationService/LocationService';
import { resolve } from 'chart.js/helpers';
import complaintService from '../services/complaintService';
import ComplaintService from '../services/complaintService';
import AssignComplaintPage from '../components/AssignComplaint/AssignComplaintPage';
import ReportService from '../services/reportService';
import API_CONFIG, { getMediaUrl } from '../config/apiConfig';
import NewComplaintPage from './NewComplaintPage';
import ApiService from '../services/api';
import authService from '../services/authService';
import TranslatedText from '../components/TranslatedText';
import { useTranslation } from 'react-i18next';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  PointElement,
  LineElement
);

// Convert English digits to Devanagari script
function toDevanagariDigits(num) {
  const devanagariDigits = '०१२३४५६७८९';
  return num.toString().replace(/\d/g, (digit) => devanagariDigits[digit]);
}

function AdminPage() {
  const [showRaiseComplaint, setShowRaiseComplaint] = useState(false);
  // Convert input date to backend format
  function toBackendDate(dateStr, endOfDay = false) {
    if (!dateStr) return '';
    return endOfDay
      ? `${dateStr} 23:59:59.999999`
      : `${dateStr} 00:00:00.000000`;
  }

  // Clear shared filter state when switching tabs
  const handleTabSwitch = (tab) => {

    setActiveTab(tab);
    setFilters({
      dateFrom: '',
      dateTo: '',
      department: '',
      taluka: '',
      category: '',
      status: '',
      raisedByCollector: false,
      raisedByCitizen: false,
    });
  };
  const dropdownRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { user: authUser, logout } = useAuth();
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [selectedOfficer, setSelectedOfficer] = useState(null);
  const [activeTab, setActiveTab] = useState('dashboard');
  const navigate = useNavigate();
  const [departments, setDepartments] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingOfficerId, setEditingOfficerId] = useState(null);
  const [complaints, setComplaints] = useState([]);
  const [totalComplaints, setTotalComplaints] = useState(0);
  const [filteredComplaints, setFilteredComplaints] = useState([]);
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [sortBy, setSortBy] = useState('date');
  const [sortOrder, setSortOrder] = useState('desc');
  const [showAssignModal, setShowAssignModal] = useState(false);

  // State for attachments and comments
  const [attachmentPreviews, setAttachmentPreviews] = useState([]);
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState('');
  const [commentType, setCommentType] = useState('public');
  const [assignComplaint, setAssignComplaint] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [stats, setStats] = useState('');
  const [counts, setCounts] = useState({
    submittedComplaints: 0,
    receivedComplaints: 0,
    pendingComplaints: 0,
    solvedComplaints: 0,
    inProgressComplaints: 0,
    acknowledgedComplaints: 0,
    rejectedComplaints: 0,
    closedComplaints: 0,
  });

  const [selectedTimeLine, setSelectedTimeLine] = useState([]);
  const handleScheduleClick = () => {
    // Placeholder for schedule logic
    // console.log('Schedule clicked');
  };

  const handleLogout = async () => {
    await logout();
  };
  const [officers, setOfficers] = useState([]);
  const [categories, setCategories] = useState([]);
  const [showAddOfficer, setShowAddOfficer] = useState(false);
  const [showAddCategory, setShowAddCategory] = useState(false);
  const [newOfficer, setNewOfficer] = useState({
    name: '',
    email: '',
    role: '',
    departmentId: '',
    // jurisdiction: ''
  });
  const [newCategory, setNewCategory] = useState({
    name: '',
    slaHours: 24,
    department: '',
  });

  const [filters, setFilters] = useState({
    dateFrom: '',
    dateTo: '',
    taluka: '',
    category: '',
    status: '',
    departmentId: '',
    raisedByCollector: false,
    raisedByCitizen: false,
  });

  // Advanced features state
  const [reportFilters, setReportFilters] = useState({
    dateFrom: '',
    dateTo: '',
    department: '',
    taluka: '',
    category: '',
    status: '',
    search: '',
  });
  const formatStatus = (status) => {
    if (!status) return '';

    // Replace underscores with spaces, convert to lowercase, then capitalize each word
    return status
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const [auditLogs, setAuditLogs] = useState([]);
  const [chatMessages, setChatMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [talukas, setTalukas] = useState([]);
  const [headerStats, setHeaderStats] = useState({});
  const [publicStats, setPublicStats] = useState({
    registered: 0,
    resolved: 0,
    loading: true,
  });

  // ✅ Citizen Attachments – Image Preview Loader
  const [imagePreviews, setImagePreviews] = useState({});
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const { i18n, t } = useTranslation();
  const currentLanguage = i18n.language;

  // const handleDownloadFromModal = async () => {
  //   // 1. Identify the source. 
  //   // Modals often wrap the attachment inside a 'selectedImage' object.
  //   const attachmentData = selectedImage?.attachment || selectedImage;

  //   if (!attachmentData) return;

  //   try {
  //     // 2. Use the same "Brute Force" discovery as the main list button
  //     const rawPath = 
  //       selectedImage?.downloadEndpoint || 
  //       attachmentData?.url || 
  //       attachmentData?.fileUrl || 
  //       attachmentData?.path || 
  //       attachmentData?.filePath;

  //     // 3. Prevent the 'apiundefined' error
  //     if (!rawPath) {
  //       alert('Unable to download. Missing file path.');
  //       return;
  //     }

  //     const endpoint = normalizeAttachmentEndpoint(rawPath);

  //     // 4. Standard Working Download Logic
  //     const blob = await ApiService.getBlob(endpoint);
  //     const objectUrl = URL.createObjectURL(blob);

  //     const link = document.createElement('a');
  //     link.href = objectUrl;

  //     // Determine extension and filename
  //     const ext = attachmentData?.fileType?.split('/')[1] || 'png';
  //     link.download = `${selectedComplaint?.complaintId || 'download'}.${ext}`;

  //     document.body.appendChild(link);
  //     link.click();

  //     // Cleanup
  //     document.body.removeChild(link);
  //     URL.revokeObjectURL(objectUrl);
  //   } catch (error) {
  //     console.error('Error downloading image:', error);
  //     alert('Error downloading image. Please try again.');
  //   }
  // };
  // Convert numbers based on language - returns Devanagari digits for Marathi, English digits otherwise
  const formatNumberForLanguage = (num, lang) => {
    if (!num && num !== 0) return '';
    if (lang === 'mr') {
      return toDevanagariDigits(num);
    }
    return num.toString();
  };

  // ✅ Standardized Date formatting helper
  const formatDateTime = (dateString) => {
    if (!dateString) return null;

    let date;
    // Handle Array format [yyyy, mm, dd, hh, mm, ss]
    if (Array.isArray(dateString)) {
      const [year, month, day, hour = 0, minute = 0, second = 0] = dateString;
      // Construct ISO string with IST offset to treat components as IST
      const iso = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}T${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}:${String(second).padStart(2, '0')}+05:30`;
      date = new Date(iso);
    } else {
      // Handle String format
      let isoString = dateString.replace(' ', 'T');
      // If no timezone indicator, assume IST (+05:30) instead of UTC (Z)
      if (!isoString.endsWith('Z') && !isoString.includes('+')) {
        isoString += '+05:30';
      }
      date = new Date(isoString);
    }

    // Invalid date check
    if (isNaN(date.getTime())) {
      return formatNumberForLanguage(dateString, currentLanguage);
    }

    // Use Intl.DateTimeFormat to force Asia/Kolkata timezone
    const options = {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    };

    try {
      const formatter = new Intl.DateTimeFormat('en-IN', options);
      const parts = formatter.formatToParts(date);
      const getPart = (type) => parts.find(p => p.type === type)?.value;

      const day = getPart('day');
      const month = getPart('month');
      const year = getPart('year');
      const hour = getPart('hour');
      const minute = getPart('minute');
      const dayPeriod = getPart('dayPeriod');

      const dateTimeStr = `${day}/${month}/${year} ${hour}:${minute} ${dayPeriod.toUpperCase()}`;
      return formatNumberForLanguage(dateTimeStr, 'en');
    } catch (e) {
      console.error('Date formatting error:', e);
      return date.toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' });
    }
  };

  // Format file size with Devanagari digits for Marathi
  const formatFileSizeWithLanguage = (sizeInBytes) => {
    if (!sizeInBytes) return 'Unknown size';
    let sizeStr = '';
    if (sizeInBytes < 1024 * 1024) {
      sizeStr = `${(sizeInBytes / 1024).toFixed(1)} KB`;
    } else {
      sizeStr = `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`;
    }
    return formatNumberForLanguage(sizeStr, currentLanguage);
  };

  useEffect(() => {
    if (!selectedComplaint || !selectedComplaint.attachments_citizen) return;

    const loadImages = async () => {
      const previews = {};
      for (const [
        index,
        attachment,
      ] of selectedComplaint.attachments_citizen.entries()) {
        try {
          const blob = await ApiService.getBlob(attachment.url);
          const objectUrl = URL.createObjectURL(blob);
          previews[index] = objectUrl;
        } catch (err) {
          console.error('Failed to load image:', err);
        }
      }
      setImagePreviews(previews);
    };

    loadImages();
  }, [selectedComplaint]);

  // Fetch public stats for Complaint Statistics tiles (reuse existing API from Home)
  useEffect(() => {
    let cancelled = false;
    const fetchPublicStats = async () => {
      try {
        const response = await dashboardService.getPublicStats();
        if (!cancelled) {
          if (response?.success) {
            setPublicStats({
              registered: response.data.registered || 0,
              resolved: response.data.resolved || 0,
              loading: false,
            });
          } else {
            setPublicStats((prev) => ({ ...prev, loading: false }));
          }
        }
      } catch (e) {
        if (!cancelled) {
          setPublicStats((prev) => ({ ...prev, loading: false }));
        }
      }
    };
    fetchPublicStats();
    return () => {
      cancelled = true;
    };
  }, []);
  const normalizeAttachmentEndpoint = (rawUrl) => {
    if (!rawUrl) return null;
    try {
      if (rawUrl.startsWith('http://') || rawUrl.startsWith('https://')) {
        const parsed = new URL(rawUrl);
        const pathWithQuery = `${parsed.pathname}${parsed.search || ''}`;
        if (pathWithQuery.startsWith('/api')) {
          return pathWithQuery.replace('/api', '') || '/';
        }
        return pathWithQuery || '/';
      }
    } catch (_) { }
    let normalized = rawUrl.startsWith('/api') ? rawUrl.replace('/api', '') : rawUrl;
    if (!normalized.startsWith('/')) normalized = `/${normalized}`;
    return normalized;
  };
  const handleViewImage = async (attachment, complaintId, isOfficer = false) => {
    try {
      const endpoint = normalizeAttachmentEndpoint(
        attachment.url || attachment.fileUrl || attachment.path
      );
      if (!endpoint) {
        alert('Unable to preview this attachment. Missing file path.');
        return;
      }

      const blob = await ApiService.getBlob(endpoint);
      const objectUrl = URL.createObjectURL(blob);

      const fileType = attachment.fileType || '';
      const ext = fileType.includes('/')
        ? fileType.split('/')[1]
        : 'bin';
      const filename = isOfficer
        ? `${complaintId}_resolution.${ext}`
        : `${complaintId}.${ext}`;

      // ✅ If it's a PDF, open it directly in a new tab
      if (fileType === 'application/pdf' || filename.toLowerCase().endsWith('.pdf')) {
        window.open(objectUrl, '_blank');
        return; // Stop here, don't show modal
      }

      // 🖼 For images and others — use modal
      setSelectedImage((prev) => {
        if (prev?.isObjectUrl && prev.url) {
          URL.revokeObjectURL(prev.url);
        }
        return {
          url: objectUrl,
          filename,
          attachment,
          downloadEndpoint: endpoint,
          isObjectUrl: true,
        };
      });
      setShowImageModal(true);
    } catch (error) {
      console.error('Error loading image:', error);
      alert('Error loading image. Please try again.');
    }
  };

  const handleDownloadFromModal = async (attachment = null) => {
    // 1. Get data from where the 'Eye' button stores it OR from the passed argument
    const data = attachment || selectedImage?.attachment || selectedImage;

    if (!data) {
      alert('No image data found.');
      return;
    }

    // 2. Locate the path. We check multiple names to ensure we don't get 'undefined'
    const rawPath = data.url || data.fileUrl || data.path || data.filePath || selectedImage.downloadEndpoint;

    if (!rawPath) {
      alert('Missing file path. Cannot download.');
      return;
    }

    // 3. Construct the clean URL (This removes 'apiundefined')
    const endpoint = normalizeAttachmentEndpoint(rawPath);

    try {
      const blob = await ApiService.getBlob(endpoint);
      const objectUrl = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = objectUrl;

      // Determine filename using the same logic as the working button
      const ext = data.fileType?.split('/')[1] || 'png';
      link.download = `${selectedComplaint?.complaintId || 'download'}.${ext}`;

      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      URL.revokeObjectURL(objectUrl);
    } catch (error) {
      console.error('Download failed:', error);
      // If the Blob/API method fails, try a direct browser download as a last resort
      window.open(endpoint, '_blank');
    }
  };

  const handleCloseImageModal = () => {
    if (selectedImage?.isObjectUrl && selectedImage.url) {
      URL.revokeObjectURL(selectedImage.url);
    }
    setShowImageModal(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    if (!showImageModal) return;
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        handleCloseImageModal();
      }
    };
    window.addEventListener('keydown', handleEscKey);
    return () => window.removeEventListener('keydown', handleEscKey);
  }, [showImageModal]);

  useEffect(() => {
    return () => {
      if (selectedImage?.isObjectUrl && selectedImage.url) {
        URL.revokeObjectURL(selectedImage.url);
      }
    };
  }, [selectedImage]);


  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  // Calculate pagination

  const [showScheduler, setShowScheduler] = useState(false);
  const LoginUser = authService.getCurrentUser();
  const departmentName = LoginUser?.departmentName;

  // Pagination handlers
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  const goToFirstPage = () => goToPage(1);
  const goToLastPage = () => goToPage(totalPages);

  const mockCategories = [
    {
      id: 1,
      name: 'Water Supply',
      slaHours: 24,
      department: 'Water Department',
    },
    {
      id: 2,
      name: 'Electricity',
      slaHours: 12,
      department: 'Electricity Board',
    },
    { id: 3, name: 'Roads', slaHours: 72, department: 'PWD' },
    {
      id: 4,
      name: 'Cleanliness',
      slaHours: 48,
      department: 'Sanitation Department',
    },
    {
      id: 5,
      name: 'Street Lights',
      slaHours: 24,
      department: 'Electricity Board',
    },
  ];

  // Mock data for advanced features
  const mockAuditLogs = [
    {
      id: 1,
      timestamp: '2024-01-22 14:30:15',
      action: 'STATUS_UPDATE',
      user: 'Rajesh Kumar',
      target: 'CMPXYZ123',
      details: 'Changed status from "Submitted" to "In Progress"',
      ipAddress: '192.168.1.100',
    },
    {
      id: 2,
      timestamp: '2024-01-22 13:45:22',
      action: 'COMPLAINT_ASSIGNED',
      user: 'Admin User',
      target: 'CMPXYZ123',
      details: 'Assigned complaint to Rajesh Kumar (Water Department)',
      ipAddress: '192.168.1.50',
    },
    {
      id: 3,
      timestamp: '2024-01-22 12:20:30',
      action: 'COMPLAINT_CREATED',
      user: 'System',
      target: 'CMPXYZ123',
      details: 'New complaint submitted by John Doe',
      ipAddress: '103.45.67.89',
    },
    {
      id: 4,
      timestamp: '2024-01-22 11:15:45',
      action: 'USER_LOGIN',
      user: 'Priya Singh',
      target: 'LOGIN_SYSTEM',
      details: 'Officer logged in successfully',
      ipAddress: '192.168.1.25',
    },
    {
      id: 5,
      timestamp: '2024-01-22 10:30:12',
      action: 'PRIORITY_CHANGE',
      user: 'Mohammed Ali',
      target: 'CMPDEF789',
      details: 'Changed priority from "Medium" to "High"',
      ipAddress: '192.168.1.75',
    },
  ];

  const mockChatMessages = [
    {
      id: 1,
      sender: 'Rajesh Kumar',
      message:
        'Need assistance with the water supply complaint in Andheri East. The pump replacement requires technical expertise.',
      timestamp: '2024-01-22 15:30:00',
      avatar: 'RK',
    },
    {
      id: 2,
      sender: 'Mohammed Ali',
      message:
        'I can help with that. I have experience with similar pump issues. Can you share the complaint details?',
      timestamp: '2024-01-22 15:32:15',
      avatar: 'MA',
    },
    {
      id: 3,
      sender: 'Priya Singh',
      message:
        'For future reference, we have a technical manual for pump replacements in the knowledge base under "Water Infrastructure".',
      timestamp: '2024-01-22 15:35:20',
      avatar: 'PS',
    },
    {
      id: 4,
      sender: 'Sunita Patil',
      message:
        'The road repair in Borivali West is completed. Updated status to resolved.',
      timestamp: '2024-01-22 16:15:30',
      avatar: 'SP',
    },
  ];
  const handlePrint = () => {
    if (!selectedComplaint) {
      alert('No complaint selected for printing.');
      return;
    }

    const printWindow = window.open('', '_blank');

    if (!printWindow) {
      alert('Popup blocked! Please allow popups for this site.');
      return;
    }

    const htmlContent = `
    <html>
    <head>
      <title>Complaint Details - ${selectedComplaint.complaintId}</title>
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; color: #333; }
        .header { border-bottom: 2px solid #B8860B; margin-bottom: 20px; padding-bottom: 10px; }
        .title { color: #B8860B; font-size: 24px; font-weight: bold; margin: 0; }
        .subtitle { color: #666; margin: 5px 0; }
        .section { margin-bottom: 20px; }
        .section-title { font-weight: bold; color: #B8860B; margin-bottom: 10px; border-bottom: 1px solid #ddd; padding-bottom: 5px; }
        .grid { display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 15px; }
        .field { margin-bottom: 8px; }
        .field-label { font-weight: bold; color: #666; }
        .description { background: #f9f9f9; padding: 10px; border-left: 4px solid #B8860B; word-wrap: break-word; overflow-wrap: anywhere; }
        .timeline-item { margin-bottom: 15px; padding-left: 15px; border-left: 2px solid #ddd; }
        .timeline-date { font-weight: bold; color: #B8860B; }
        .timeline-action { font-weight: bold; margin: 5px 0; }
        .timeline-note { color: #666; margin: 5px 0; }
        @media print {
          body { margin: 0; }
          .no-print { display: none !important; }
          .page-break { page-break-after: avoid; page-break-inside: avoid; }
        }
      </style>
    </head>
    <body>
      <div class="page-break">
        <div class="header">
          <h1 class="title">Government Complaint Management System</h1>
          <p class="subtitle">Official Complaint Details Report</p>
        </div>

        <div class="section">
          <div class="section-title">Complaint Information</div>
          <div class="grid">
            <div class="field"><span class="field-label">Complaint ID:</span> ${selectedComplaint.complaintId || 'N/A'}</div>

            <div class="field"><span class="field-label">Status:</span> ${formatStatus(selectedComplaint.status) || 'N/A'}</div>
            <div class="field"><span class="field-label">Priority:</span> ${selectedComplaint.priority || 'N/A'}</div>
            <div class="field"><span class="field-label">Date Submitted:</span> ${selectedComplaint.submittedDate || 'N/A'}</div>
            <div class="field"><span class="field-label">Assigned To:</span> ${selectedComplaint.assignedTo || 'N/A'}</div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">Citizen Details</div>
          <div class="field"><span class="field-label">Name:</span> ${selectedComplaint.name || 'N/A'}</div>
          <div class="field"><span class="field-label">Mobile:</span> ${selectedComplaint.mobile || 'N/A'}</div>
          <div class="field"><span class="field-label">Address:</span> ${selectedComplaint.address || 'N/A'}</div>
          <div class="field"><span class="field-label">Village:</span> ${selectedComplaint.village || 'N/A'}</div>
        </div>

        <div class="section">
          <div class="section-title">Complaint Description</div>
          <div class="description">${selectedComplaint.description || 'N/A'}</div>
        </div>

        ${selectedComplaint.assignmentReason
        ? `
        <div class="section">
          <div class="section-title">Assignment Information</div>
          <div class="description">
            <p><strong>Assigned To:</strong> ${selectedComplaint.assignedTo || 'N/A'}</p>
            <p><strong>Assigned Date:</strong> ${selectedComplaint.assignedDate || 'N/A'}</p>
            <p><strong>Assignment Reason:</strong> ${selectedComplaint.assignmentReason}</p>
          </div>
        </div>
        `
        : ''
      }

        ${selectedComplaint.officerNotes
        ? `
        <div class="section">
          <div class="section-title">Officer Notes</div>
          <div class="description">${selectedComplaint.officerNotes}</div>
        </div>
        `
        : ''
      }

        <div class="section">
          <div class="section-title">Action Timeline</div>
          ${selectedComplaint.timeline && selectedComplaint.timeline.length > 0
        ? selectedComplaint.timeline
          .map(
            (event) => `
              <div class="timeline-item">
                <div class="timeline-date">${event.date || ''}</div>
                <div class="timeline-action">${event.action || ''}</div>
                <div class="timeline-note">${event.note || ''}</div>
                <div style="font-size: 12px; color: #999;">By: ${event.officerName || selectedComplaint.raisedBy || 'Citizen'}</div>
              </div>
            `
          )
          .join('')
        : '<p>No timeline information available.</p>'
      }
        </div>

        <div style="margin-top:40px; text-align:center; font-size:12px; color:#666;">
          <p>This is an official document generated from the Government Complaint Management System</p>
          <p>Generated on ${new Date().toLocaleString()}</p>
        </div>
      </div>
    </body>
    </html>
  `;

    printWindow.document.open();
    printWindow.document.write(htmlContent);
    printWindow.document.close();

    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
      // Optionally close the window after printing:
      // printWindow.close();
    };
  };
  useEffect(() => {
    const onKeyDown = (e) => {
      // Windows/Linux: Ctrl+P, macOS: Meta+P (Cmd+P)
      const isPrintShortcut =
        (e.ctrlKey && e.key.toLowerCase() === 'p') ||
        (e.metaKey && e.key.toLowerCase() === 'p');

      if (isPrintShortcut) {
        e.preventDefault();
        e.stopPropagation();
        handlePrint();
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [handlePrint]);
  const mockKnowledgeBase = [
    {
      id: 1,
      title: 'Water Pump Replacement Procedure',
      category: 'Water Infrastructure',
      content:
        'Step-by-step guide for replacing water pumps in residential buildings...',
      lastUpdated: '2024-01-15',
      updatedBy: 'Mohammed Ali',
    },
    {
      id: 2,
      title: 'Road Pothole Repair Standards',
      category: 'Road Maintenance',
      content:
        'Standard operating procedures for pothole repairs and quality checks...',
      lastUpdated: '2024-01-18',
      updatedBy: 'Sunita Patil',
    },
    {
      id: 3,
      title: 'Electricity Connection Issues',
      category: 'Electrical Systems',
      content:
        'Common electrical issues and troubleshooting guide for field officers...',
      lastUpdated: '2024-01-20',
      updatedBy: 'Deepak Joshi',
    },
    {
      id: 4,
      title: 'SLA Guidelines and Escalation Matrix',
      category: 'Process Guidelines',
      content:
        'Complete guide to SLA timelines and when to escalate complaints...',
      lastUpdated: '2024-01-10',
      updatedBy: 'Admin User',
    },
  ];
  useEffect(() => {
    if (selectedComplaint) {
    }
  }, [selectedComplaint]);

  useEffect(() => {
    const fetchAllOfficers = async () => {
      try {
        const data = await getOfficers();
        setOfficers(data);
      } catch (error) { }
    };
    fetchAllOfficers();
    setCategories(mockCategories);
    setAuditLogs(mockAuditLogs);
    setChatMessages(mockChatMessages);
  }, []);

  // Handle back button with logout confirmation
  useEffect(() => {
    const handleBackButton = (event) => {
      event.preventDefault();
      const confirmLogout = window.confirm('Do you want to logout?');
      if (confirmLogout) {
        logout();
      } else {
        // Stay on current page
        window.history.pushState(null, '', window.location.pathname);
      }
    };

    // Add current entry to history stack
    window.history.pushState(null, '', window.location.pathname);

    // Listen for popstate (back button)
    window.addEventListener('popstate', handleBackButton);

    return () => {
      window.removeEventListener('popstate', handleBackButton);
    };
  }, [logout]);

  const handleDownloadComplaintCountReport = async () => {
    const result = await dashboardService.getComplaintCountReport();
    if (result.success) {
    } else {
      console.error(
        'Failed to download complaint count report:',
        result.message
      );
    }
  };

  const handlePriorityUpdate = async (complaintId, priority) => {
    try {
      // Always await the API call
      const result = await dashboardService.updatePriority(
        complaintId,
        priority
      );

      // Check if backend returned a success response
      if (result?.success || result?.status === 200) {


        // Update selected complaint (modal view)
        setSelectedComplaint((prev) =>
          prev && prev.id === complaintId ? { ...prev, priority } : prev
        );

        // Update complaint list (table view)
        setComplaints((prev) =>
          prev.map((c) => (c.id === complaintId ? { ...c, priority } : c))
        );

        // Refresh page data
        await fetchComplaintsPage();
      } else {
        console.error('❌ Failed to update priority on server:', result);
      }
    } catch (error) {
      console.error('⚠️ Error updating priority on server:', error);
    }
  };

  const handleDownloadAgingReport = async () => {
    try {
      const result = await dashboardService.getComplaintAgingReport();

      if (result.success) {


      }
    } catch (error) {
      console.error('Failed to download aging report:', error);
    }
  };
  const fetchComplaintsPage = async () => {
    try {
      setLoading(true);
      const response = await complaintService.getComplaints({
        page: currentPage - 1,
        size: itemsPerPage,
        status: filters.status !== 'ALL STATUS' ? filters.status : undefined,
        departmentId: filters.departmentId,
        taluka: filters.taluka,
        dateTo: toBackendDate(filters.dateTo, true),
        dateFrom: toBackendDate(filters.dateFrom, false),
        search: reportFilters.search.trim(),
        raisedBy:
          filters.raisedByCollector && !filters.raisedByCitizen
            ? 'COLLECTOR'
            : !filters.raisedByCollector && filters.raisedByCitizen
              ? 'CITIZEN'
              : undefined,
      });

      const data = response.data || response;
      const normalized = normalizeComplaintData(data.content || []);
      setComplaints(normalized || []);
      setSelectedComplaint((prev) => {
        if (!prev) return null;
        const updated = normalized.find((c) => c.id === prev.id);
        if (updated) {
          const reversedTimeline = [...(updated.timeline || [])].reverse();
          setSelectedTimeLine(reversedTimeline || []);
          return updated;
        } else {
          setSelectedTimeLine([]);
          return null;
        }
      });
      setTotalPages(data.totalPages || 0);
      setTotalComplaints(data.totalElements || 0);
    } catch (err) {
      // Check if it's a session expiration error
      if (err.message && err.message.includes('Session expired')) {
        setError('Session expired. Redirecting to login...');
      } else {
        setError('Failed to fetch complaints');
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchComplaintsPage();

    // Auto-refresh complaints every 30 seconds
    const intervalId = setInterval(() => {
      fetchComplaintsPage();
    }, 30000);

    // Cleanup interval on unmount or when dependencies change
    return () => clearInterval(intervalId);
  }, [
    currentPage,
    itemsPerPage,
    filters,
    reportFilters.search,
    sortBy,
    sortOrder,
  ]);

  const normalizeComplaintData = (data) => {
    if (!Array.isArray(data)) return [];

    return data.map((item) => ({
      id: item.id,
      complaintId: item.complaintId,
      departmentId: item.departmentId, // ✅ Added for filtering
      name: item.name,
      mobile: item.mobile,
      village: item.village,
      taluka: item.taluka,
      departmentName: item.departmentName,
      description: item.description,
      status: item.status,
      priority: item.priority,
      submittedDate: formatDateTime(item.submittedDate),
      rawSubmittedDate: item.submittedDate,
      assignedDate: item.assignedDate
        ? formatDateTime(item.assignedDate)
        : null,
      raisedBy: item.raisedBy,
      assignedTo: item.assignedTo,
      assignedBy: item.assignedBy,
      officerNotes: item.officerNotes,
      email: item.email,
      address: item.address,
      resolvedDate: item.resolvedDate
        ? formatDateTime(item.resolvedDate)
        : null,
      pendingDays: item.pendingDays,
      timeline: item.timeline?.map((t) => ({
        date: formatDateTime(t.date),
        status: t.status,
        description: t.description,
        action: t.action,
        officerName: t.officerName || '',
      })),
      comments: item.comments?.map((c) => ({
        id: c.id,
        comment: c.comment,
        by: c.commentBy,
        type: c.commenterType,
        visibility: c.visibility,
        createdAt: formatDateTime(c.createdAt),
      })),

      attachments_officer: item.attachments_officer?.map((a) => ({
        complaint_code: a.complaint_code,
        fileName: a.fileName,
        fileType: a.fileType,
        id: a.id,
        size: a.size,
        uploadedAt: formatDateTime(a.uploadedAt),
        url: a.url,
      })),
      attachments_citizen: item.attachments_citizen?.map((a) => ({
        complaint_code: a.complaint_code,
        fileName: a.fileName,
        fileType: a.fileType,
        id: a.id,
        size: a.size,
        uploadedAt: formatDateTime(a.uploadedAt),
        url: a.url,
      })),
    }));
  };

  //fetsh dashboard stats
  useEffect(() => {
    async function fetchStats() {
      try {
        const data = await complaintService.getComplaintStats();

        setStats(data);
      } catch (error) {
        console.error('Error fetching dashboard stats:', error.message);
      } finally {
        setLoading(false);
      }
    }

    fetchStats();
  }, []);

  useEffect(() => {
    async function fetchDashboardStats() {
      try {
        const data = await complaintService.getDashboardComplaints();

        setCounts(data);
      } catch (error) {
        console.error('Error fetching dashboard stats:', error.message);
      } finally {
        setLoading(false);
      }
    }

    fetchDashboardStats();
  }, []);

  useEffect(() => {
    async function fetchHeaderStats() {
      try {
        const data = await ComplaintService.getStats();

        let averageTat = 0;
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${API_CONFIG.BASE_URL}/analytics/average-tat`, {
            headers: { 'Authorization': `Bearer ${token}` }
          });
          const tatResponse = await response.json();
          
          averageTat = typeof tatResponse === 'object' && tatResponse !== null 
            ? (tatResponse.data?.averageTatDays ?? tatResponse.averageTatDays ?? tatResponse.data?.averageTat ?? tatResponse.averageTat ?? tatResponse.average ?? tatResponse.data ?? 0)
            : tatResponse;

          // Round to 2 decimal places if it's a number
          if (typeof averageTat === 'number') {
            averageTat = Math.round(averageTat * 100) / 100;
          }
        } catch (error) {
          console.error('Error fetching average TAT:', error);
        }

        setHeaderStats({
          ...data,
          averageTat: typeof averageTat === 'number' ? averageTat : parseFloat(averageTat) || 0,
        });


      } catch (error) {
        console.error('Error fetching header stats:', error.message);
      } finally {
        setLoading(false);
      }
    }
    fetchHeaderStats();
  }, []);
  // We'll use authUser directly instead of local user state

  useEffect(() => {
    const loadDepartments = async () => {
      try {
        const data = await fetchDepartments();
        setDepartments(data); // assuming API returns array of departments
      } catch (error) {
        console.error('Failed to load departments', error);
      }
    };
    loadDepartments();
  }, []);

  //fetch takukas
  useEffect(() => {
    fetchTalukas()
      .then((data) => {
        if (Array.isArray(data)) {
          setTalukas(
            data.map((t) => ({ id: t.taluka_id, name: t.taluka_name }))
          );
        } else {
          setTalukas([]);
        }
      })
      .catch(() => setTalukas([]));
  }, []);

  //filter complaints based on filters

  useEffect(() => {

    let filtered = [...complaints]; // Create a copy to avoid mutating state during sort

    // Search functionality
    if (reportFilters.search) {
      const query = reportFilters.search.toLowerCase();
      filtered = filtered.filter(
        (complaints) =>
          complaints.complaintId?.toLowerCase().includes(query) ||
          complaints.name?.toLowerCase().includes(query) ||
          complaints.mobile?.toLowerCase().includes(query) ||
          complaints.village?.toLowerCase().includes(query) ||
          complaints.taluka?.toLowerCase().includes(query) ||
          (() => {
            const s = (complaints.status || '').toUpperCase();
            const q = query.toUpperCase();
            if (q === 'REOPEN' || q === 'REOPENED') {
              return s === 'REOPEN' || s === 'REOPENED';
            }
            return complaints.status?.toLowerCase().includes(query);
          })() ||
          complaints.assignedTo?.toLowerCase().includes(query) ||
          complaints.officerAssigned?.toLowerCase().includes(query) ||
          complaints.priority.toLowerCase().includes(query) ||
          complaints.departmentName?.toLowerCase().includes(query) ||
          complaints.submittedDate?.toLowerCase().includes(query) ||
          complaints.resolvedDate?.toLowerCase().includes(query)
      );
    }


    // Sorting with COLLECTOR complaints prioritized at the top
    filtered.sort((a, b) => {
      const aIsCollector = a.raisedBy === 'COLLECTOR';
      const bIsCollector = b.raisedBy === 'COLLECTOR';

      // Step 1: Always keep COLLECTOR complaints at the top
      if (aIsCollector && !bIsCollector) return -1;
      if (!aIsCollector && bIsCollector) return 1;

      // Step 2: Within same group, apply your sortBy logic
      let aValue, bValue;

      switch (sortBy) {
        case 'date':
          aValue = new Date(a.rawSubmittedDate || a.submittedDate);
          bValue = new Date(b.rawSubmittedDate || b.submittedDate);
          // Always sort by latest first (descending)
          return bValue - aValue;

        case 'priority':
          const priorityOrder = { Critical: 4, High: 3, Medium: 2, Low: 1 };
          aValue = priorityOrder[a.priority] || 0;
          bValue = priorityOrder[b.priority] || 0;
          return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;

        case 'status':
          aValue = a.status?.toLowerCase() || '';
          bValue = b.status?.toLowerCase() || '';
          return sortOrder === 'asc'
            ? aValue.localeCompare(bValue)
            : bValue.localeCompare(aValue);

        default:
          aValue = a[sortBy];
          bValue = b[sortBy];
          if (sortOrder === 'asc') return aValue > bValue ? 1 : -1;
          else return aValue < bValue ? 1 : -1;
      }
    });

    setFilteredComplaints(filtered);
    // setCurrentPage(1);
  }, [complaints, filters, reportFilters.search, sortBy, sortOrder]);


  const getPayload = () => ({
    fromDate: filters.dateFrom,
    toDate: filters.dateTo,
    departmentId: filters.departmentId,
    taluka: filters.taluka,
    status: filters.status.toUpperCase(), // ensure backend expects uppercase
  });
  // ✅ PDF Export
  const handleGenerateReport = async () => {
    // if (!validateFilters()) return;

    try {
      await complaintService.generateComplaintsReport(getPayload());
    } catch (err) {
      console.error(err);
      alert('Failed to generate pdf report');
    }
  };

  const handleDailyCRMReport = () => {

    setOpen(false);
  };
  // ✅ Excel Export
  const handleGenerateExcel = async () => {
    try {
      await complaintService.generateComplaintsExcel(getPayload());
    } catch (err) {
      console.error(err);
      alert('Failed to generate Excel report');
    }
  };

  //add officer
  const handleAddOfficer = async (e) => {
    e.preventDefault();
    const officer = {
      ...newOfficer,
      status: 'Active',
    };
    const createdOfficer = await addOfficer(officer);
    setOfficers([...officers, createdOfficer]);
    setNewOfficer({
      id: '',
      name: '',
      email: '',
      userName: '',
      role: '',
      departmentId: '',
      // jurisdiction: ''
    });
    setShowAddOfficer(false);
  };

  const handleEditOfficer = async (e) => {
    e.preventDefault();
    try {
      const updatedOfficer = {
        ...newOfficer,
        status: 'Active',
      };
      await editOfficer(editingOfficerId, updatedOfficer);
      // Refresh officers list or update locally
      const updatedList = officers.map((officer) =>
        officer.id === editingOfficerId
          ? { ...officer, ...updatedOfficer }
          : officer
      );
      setOfficers(updatedList);
      setShowAddOfficer(false);
      setIsEditMode(false);
      setEditingOfficerId(null);
      setNewOfficer({
        name: '',
        email: '',
        userName: '',
        role: '',
        departmentId: '',
        jurisdiction: '',
        password: '',
        userId: '',
      });
    } catch (error) {
      alert('Failed to update officer');
      console.error(error);
    }
  };

  const handleAddCategory = (e) => {
    e.preventDefault();
    const category = {
      id: categories.length + 1,
      ...newCategory,
    };
    setCategories([...categories, category]);
    setNewCategory({ name: '', slaHours: 24, department: '' });
    setShowAddCategory(false);
  };

  const handleDeleteOfficer = async (id) => {
    const confirmed = window.confirm(
      'Are you sure you want to delete this officer?'
    );
    if (!confirmed) return;
    try {
      await deleteOfficer(id);
      setOfficers(officers.filter((officer) => officer.id !== id));
    } catch (error) {
      alert('Failed to delete officer');
      console.error(error);
    }
  };

  const handleDeleteCategory = (id) => {
    setCategories(categories.filter((category) => category.id !== id));
  };

  const handleResetPassword = (officer) => {
    setSelectedOfficer(officer);
    setShowResetPassword(true);
  };

  const handleFilterChange = (e) => {
    setFilters((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleStatusUpdate = (complaintId, newStatus) => {
    // If reopening, set status to IN_PROGRESS
    if (newStatus === 'REOPEN') {
      newStatus = 'IN_PROGRESS';
    }

    setComplaints((prev) =>
      prev.map((complaint) =>
        complaint.id === complaintId
          ? { ...complaint, status: newStatus }
          : complaint
      )
    );
  };

  const handleViewDetails = async (complaint) => {
    setSelectedComplaint(complaint);


    const reverseTimeLine = Array.isArray(complaint.timeline)
      ? [...complaint.timeline].reverse()
      : [];

    setSelectedTimeLine(reverseTimeLine);


    setShowDetailModal(true);

    // Load existing comments from API
    try {
      const complaintId = complaint.id || complaint.complaintId;
      const apiComments = await ComplaintService.getComments(complaintId);
      // If API returns an array, use it; else fallback to empty array
      setComments(Array.isArray(apiComments) ? apiComments : []);
    } catch (error) {
      setComments([]);
      console.error('Failed to fetch comments:', error);
    }
  };

  const handleCloseModal = () => {
    setShowDetailModal(false);
    setSelectedComplaint(null);
    // Reset modal state
    setNewComment('');
    setCommentType('public');
    setComments([]);
  };

  // Handle adding comments
  const handleAddComment = async () => {
    if (!newComment.trim() || !selectedComplaint) return;

    const complaintId = selectedComplaint.id || selectedComplaint.complaintId;
    const username =
      authUser?.name ||
      authUser?.username ||
      authUser?.email ||
      'Admin Officer';

    const payload = {
      comment: newComment,
      commenterName: username,
      visibility: commentType === 'INTERNAL' ? 'INTERNAL' : 'PUBLIC',
    };

    try {
      // Call API to save comment
      await ComplaintService.addComment(complaintId, payload);

      // Update local state
      const newCommentObj = {
        id: Date.now(),
        comment: newComment,
        commentBy: username,
        visibility: commentType.charAt(0).toUpperCase() + commentType.slice(1),
        type: commentType,
        createdAt: new Date().toLocaleString(),
      };
      await fetchComplaintsPage();
      setComments((prev) => [newCommentObj, ...prev]);
      setNewComment('');
    } catch (error) {
      console.error('Failed to add comment:', error);
      // You might want to show an error message to the user here
    }
  };
  // Add this function to your component

  const handleAssignClick = (complaint) => {
    setAssignComplaint(complaint);
    setShowAssignModal(true);
  };

  const handleAssignClose = () => {
    setShowAssignModal(false);
    setAssignComplaint(null);
  };

  const handleAssign = async (assignData) => {
    // TODO: Implement assignment logic (API call, state update, etc.)
    await fetchComplaintsPage();
    setShowAssignModal(false);
    setAssignComplaint(null);
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'NEW':
      case 'New':
        return 'bg-blue-100 text-blue-800';
      case 'IN_PROGRESS':
      case 'In Progress':
        return 'bg-yellow-100 text-yellow-800';
      case 'RESOLVED':
      case 'Resolved':
        return 'bg-green-100 text-green-800';
      case 'PENDING':
      case 'Pending':
        return 'bg-orange-100 text-orange-800';
      case 'REJECTED':
      case 'Rejected':
        return 'bg-red-100 text-red-800';
      case 'REOPEN':
      case 'REOPENED':
      case 'Reopen':
      case 'reopen':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getPendingDaysStatusColor = (PendingDays) => {
    switch (PendingDays) {
      case '7 days':
        return 'bg-yellow-100 text-yellow-800';
      case '14 days':
        return 'bg-orange-100 text-orange-800';
      case '21 days':
        return 'bg-red-100 text-red-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'HIGH':
      case 'HIGH':
        return 'bg-red-100 text-red-800';
      case 'MEDIUM':
      case 'MEDIUM':
        return 'bg-yellow-100 text-yellow-800';
      case 'LOW':
      case 'LOW':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getStatsCounts = () => {
    return {
      total: complaints.length,
      submitted: complaints.filter((c) => c.status === 'Submitted').length,
      inProgress: complaints.filter((c) => c.status === 'In Progress').length,
      resolved: complaints.filter((c) => c.status === 'Resolved').length,
      escalated: complaints.filter((c) => c.status === 'Escalated').length,
    };
  };

  const states = getStatsCounts();

  /// Render Dashboard Tab
  const renderDashboardTab = () => {
    if (!stats) {
      return <p>Loading...</p>;
    }
    const talukaBarChartData = {
      labels: stats.talukaWiseComplaints?.map((item) => t(`taluka.${item.taluka}`)) || [],
      datasets: [
        {
          label: t('admin.cards.totalComplaints'),
          data: stats.talukaWiseComplaints?.map((item) => item.total) || [],
          backgroundColor: 'rgba(59, 130, 246, 0.8)',
          borderColor: 'rgba(59, 130, 246, 1)',
          borderWidth: 1,
        },
        {
          label: t('admin.cards.resolved'),
          data: stats.talukaWiseComplaints?.map((item) => item.resolved) || [],
          backgroundColor: 'rgba(34, 197, 94, 0.8)',
          borderColor: 'rgba(34, 197, 94, 1)',
          borderWidth: 1,
        },
        {
          label: t('admin.cards.pending'),
          data: stats.talukaWiseComplaints?.map((item) => item.pending) || [],
          backgroundColor: 'rgba(251, 191, 36, 0.8)',
          borderColor: 'rgba(251, 191, 36, 1)',
          borderWidth: 1,
        },
      ],
    };

    const categoryDoughnutData = {
      labels: stats.categoryWiseData?.map((item) => t(`department.${item.category}`)) || [],
      datasets: [
        {
          data: stats.categoryWiseData?.map((item) => item.count) || [],
          backgroundColor: [
            'rgba(59, 130, 246, 0.8)',
            'rgba(34, 197, 94, 0.8)',
            'rgba(251, 191, 36, 0.8)',
            'rgba(239, 68, 68, 0.8)',
            'rgba(168, 85, 247, 0.8)',
            'rgba(6, 182, 212, 0.8)',
          ],
          borderColor: [
            'rgba(59, 130, 246, 1)',
            'rgba(34, 197, 94, 1)',
            'rgba(251, 191, 36, 1)',
            'rgba(239, 68, 68, 1)',
            'rgba(168, 85, 247, 1)',
            'rgba(6, 182, 212, 1)',
          ],
          borderWidth: 2,
        },
      ],
    };

    const chartOptions = {
      responsive: true,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: false,
        },
      },
    };

    return (
      <div className="space-y-8">
        {/* Key Metrics Overview */}
        <div className={`grid grid-cols-1 gap-6 md:grid-cols-2 ${['collector', 'admin'].includes(authUser?.role?.toLowerCase()) ? 'lg:grid-cols-6' : 'lg:grid-cols-5'}`}>
          {/* Total Complaints */}
          <div
            className="cursor-pointer rounded-xl bg-gradient-to-br from-blue-500 to-blue-600 p-6 text-white transition-all hover:shadow-xl"
            onClick={() => setFilters({ ...filters, status: 'ALL STATUS' })}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-blue-100">
                  {t('admin.cards.totalComplaints')}
                </p>
                <p className="text-3xl font-bold">
                  {formatNumberForLanguage(headerStats?.totalComplains ?? 0, currentLanguage)}
                </p>
              </div>
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-blue-400 bg-opacity-30">
                <FileText className="h-6 w-6" />
              </div>
            </div>
          </div>

          {/* Resolved */}
          <div
            className="cursor-pointer rounded-xl bg-gradient-to-br from-green-500 to-green-600 p-6 text-white transition-all hover:shadow-xl"
            onClick={() => setFilters({ ...filters, status: 'RESOLVED' })}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-green-100">{t('status.resolved')}</p>
                <p className="text-3xl font-bold">
                  {formatNumberForLanguage(headerStats?.totalResolvedComplaints ?? 0, currentLanguage)}
                </p>
              </div>
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-green-400 bg-opacity-30">
                <BarChart3 className="h-6 w-6" />
              </div>
            </div>
          </div>

          {/* Pending = Total - Resolved - Rejected */}
          <div
            className="cursor-pointer rounded-xl bg-gradient-to-br from-amber-500 to-amber-600 p-6 text-white transition-all hover:shadow-xl"
            onClick={() => setFilters({ ...filters, status: 'PENDING' })}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-amber-100">{t('cards.pending')}</p>
                <p className="text-3xl font-bold">
                  {formatNumberForLanguage((headerStats?.totalComplains || 0) - (headerStats?.totalResolvedComplaints || 0) - (headerStats?.totalRejectedComplaints || 0), currentLanguage)}
                </p>
              </div>
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-amber-400 bg-opacity-30">
                <Users className="h-6 w-6" />
              </div>
            </div>
          </div>

          {/* Rejected */}
          <div
            className="cursor-pointer rounded-xl bg-gradient-to-br from-red-500 to-red-600 p-6 text-white transition-all hover:shadow-xl"
            onClick={() => setFilters({ ...filters, status: 'REJECTED' })}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-red-100"><TranslatedText>Rejected</TranslatedText></p>
                <p className="text-3xl font-bold">
                  {formatNumberForLanguage(headerStats?.totalRejectedComplaints ?? 0, currentLanguage)}
                </p>
              </div>
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-red-400 bg-opacity-30">
                <X className="h-6 w-6" />
              </div>
            </div>
          </div>

          {/* Overdue */}
          <div
            className="cursor-pointer rounded-xl bg-gradient-to-br from-purple-500 to-purple-600 p-6 text-white transition-all hover:shadow-xl"
            onClick={() => setFilters({ ...filters, status: 'OVERDUE' })}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm font-medium text-red-100">
                  {t('cards.overdue21Days')}
                </p>
                <p className="text-3xl font-bold">
                  {formatNumberForLanguage(headerStats?.totalOverdueComplaints, currentLanguage)}
                </p>
              </div>
              <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-purple-400 bg-opacity-30">
                <Search className="h-6 w-6" />
              </div>
            </div>
          </div>

          {/* Average TAT */}
          {['collector', 'admin'].includes(authUser?.role?.toLowerCase()) && (
            <div
              className="cursor-pointer rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 p-6 text-white transition-all hover:shadow-xl"
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium text-indigo-100">
                    <TranslatedText>Average TAT (Days)</TranslatedText>
                  </p>
                  <p className="text-3xl font-bold">
                    {formatNumberForLanguage(headerStats?.averageTat || 0, currentLanguage)}
                  </p>
                </div>
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-indigo-400 bg-opacity-30">
                  <Clock className="h-6 w-6" />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg">
          <div className="flex items-center justify-between border-b border-gray-200 bg-gray-50 px-6 py-4">
            <h3 className="text-xl font-semibold text-gray-900">
              {t('admin.section.complaintsManagement')}
            </h3>
            <button
              className="rounded-lg bg-blue-600 px-6 py-2 font-semibold text-white shadow hover:bg-blue-700"
              onClick={() => setShowRaiseComplaint(true)}
            >
              {t('admin.section.raiseComplaint')}
            </button>
          </div>

          {/* Search and Filters */}
          <div className="border-b border-gray-200 bg-gray-50 p-6">
            <div className="mb-4">
              <div className="relative">
                <Search className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 transform text-gray-400" />
                <input
                  type="text"
                  value={reportFilters.search}
                  onChange={(e) =>
                    setReportFilters((prev) => ({
                      ...prev,
                      search: e.target.value,
                    }))
                  }
                  placeholder={t('admin.search.placeholder')}
                  className="w-full rounded-lg border border-gray-300 py-3 pl-10 pr-4 transition-colors focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
            <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-4">
              {/* Status  */}
              <select
                name="status"
                value={filters.status}
                onChange={handleFilterChange}
                className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm focus:border-transparent focus:ring-2 focus:ring-blue-500"
              >
                <option value="ALL STATUS">{t('status.allStatus')}</option>
                <option value="NEW">{t('status.new')}</option>
                <option value="IN_PROGRESS">{t('status.inProgress')}</option>
                <option value="REOPEN">{t('status.reopened')}</option>
                <option value="RESOLVED">{t('status.resolved')}</option>
                <option value="REJECTED">{t('status.rejected')}</option>
                <option value="PENDING">{t('status.pending')}</option>
              </select>

              {/* Taluka  */}
              <select
                name="taluka"
                value={filters.taluka}
                onChange={(e) =>
                  setFilters({ ...filters, taluka: e.target.value })
                }
                required
                className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm focus:border-transparent focus:ring-2 focus:ring-blue-500"
              >
                <option value=""><TranslatedText>Select Taluka</TranslatedText></option>
                {talukas.map((taluka) => (
                  <option key={taluka.id} value={taluka.name}>
                    <TranslatedText>{t(`taluka.${taluka.name}`, { defaultValue: taluka.name })}</TranslatedText>
                  </option>
                ))}
              </select>

              {/* Department  */}
              <select
                name="department"
                value={filters.departmentId || ''}
                onChange={(e) => {
                  const selectedDep = departments.find(
                    (dep) => dep.id.toString() === e.target.value
                  );
                  setFilters({
                    ...filters,
                    department: selectedDep?.name || '',
                    departmentId: selectedDep?.id || '',
                  });
                }}
                required
                className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 shadow-sm focus:border-transparent focus:ring-2 focus:ring-blue-500"
              >
                <option value=""><TranslatedText>Department</TranslatedText></option>
                {departments.map((dep) => (
                  <option key={dep.id} value={dep.id}>
                    <TranslatedText>{t(`department.${dep.name}`, { defaultValue: dep.name })}</TranslatedText>
                  </option>
                ))}
              </select>

              {/* From-To Date */}
              <div className="flex gap-2">
                <input
                  type="date"
                  name="dateFrom"
                  value={filters.dateFrom}
                  onChange={(e) =>
                    setFilters({ ...filters, dateFrom: e.target.value })
                  }
                  max={new Date().toISOString().split('T')[0]}
                  placeholder="From Date"
                  className="w-1/2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                />
                <input
                  type="date"
                  name="dateTo"
                  value={filters.dateTo}
                  onChange={(e) =>
                    setFilters({ ...filters, dateTo: e.target.value })
                  }
                  max={new Date().toISOString().split('T')[0]}
                  placeholder="To Date"
                  className="w-1/2 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm shadow-sm transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
                />
              </div>
            </div>

            <div className="mt-4 flex items-center justify-between">
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-2">
                  {/* <label className="text-sm font-medium text-gray-700">Sort by:</label>
                  <select
                    value={sortBy}
                    onChange={(e) => setSortBy(e.target.value)}
                    className="rounded border border-gray-300 px-3 py-1 text-sm focus:ring-1 focus:ring-blue-500"
                  >
                    <option value="date"> Date</option>
                    <option value="priority">Priority</option>
                    <option value="status">Status</option>
                    <option value="Taluka">Taluka</option>
                  </select> */}
                  {/* <button
                    onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                    className="rounded px-2 py-1 text-sm text-blue-600 hover:text-blue-800"
                  >
                    {sortOrder === 'asc' ? '↑' : '↓'}
                  </button> */}
                </div>
              </div>
            </div>
          </div>

          {/* Raise Complaint Modal */}
          {showRaiseComplaint && (
            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-40">
              <div className="bg-white rounded-xl shadow-2xl p-6 max-w-3xl w-full relative max-h-[90vh] overflow-y-auto">
                <button
                  className="absolute right-2 top-2 text-2xl font-bold text-gray-500 hover:text-gray-700"
                  onClick={() => setShowRaiseComplaint(false)}
                  aria-label="Close"
                >
                  ×
                </button>
                <NewComplaintPage />
              </div>
            </div>
          )}

          {/* Interactive Filter Legend */}
          <div className="border-b border-gray-200 bg-gray-50 px-6 py-3">
            <div className="flex select-none items-center gap-4 text-xs text-gray-600">
              <div
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    raisedByCollector: !prev.raisedByCollector,
                    raisedByCitizen: !prev.raisedByCollector ? false : prev.raisedByCitizen,
                  }))
                }
                className={`flex items-center gap-1.5 cursor-pointer px-2 py-1 rounded transition-all border ${filters.raisedByCollector
                  ? 'bg-purple-100 border-purple-300 shadow-sm'
                  : 'hover:bg-gray-100 border-transparent'
                  }`}
              >
                <span className="h-3 w-3 rounded bg-purple-600"></span>
                <span className="font-semibold text-purple-700">★ {t('legend.collectorPriority')}</span>
              </div>
              <span className="text-gray-400">|</span>
              <div
                onClick={() =>
                  setFilters((prev) => ({
                    ...prev,
                    raisedByCitizen: !prev.raisedByCitizen,
                    raisedByCollector: !prev.raisedByCitizen ? false : prev.raisedByCollector,
                  }))
                }
                className={`flex items-center gap-1.5 cursor-pointer px-2 py-1 rounded transition-all border ${filters.raisedByCitizen
                  ? 'bg-blue-100 border-blue-300 shadow-sm'
                  : 'hover:bg-gray-100 border-transparent'
                  }`}
              >
                <span className="h-3 w-3 rounded border border-gray-300 bg-white"></span>
                <span className={filters.raisedByCitizen ? 'text-blue-800 font-medium' : ''}>
                  {t('legend.citizenRaised')}
                </span>
                {filters.raisedByCitizen && <span className="ml-1 text-blue-600">✓</span>}
              </div>
            </div>
          </div>

          {/* Complaints Table */}
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="border-b border-gray-100">
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.complaintId')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.submittedDate')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.resolvedDate')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.citizenDetails')}
                  </th>
                  <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.priority')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.taluka')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.department')}
                  </th>
                  {/* <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
    {t('dashboard.table.officerAssign')}
  </th> */}
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.status')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.pendingDays')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.raisedBy')}
                  </th>
                  <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    {t('dashboard.table.actions')}
                  </th>
                </tr>

              </thead>

              <tbody className="bg-white">
                {complaints.map((complaint) => {
                  // Status key mapping for translation (IN_PROGRESS → status.inProgress)
                  const formatStatusKey = (status) => {
                    if (!status) return '';
                    const words = status.toLowerCase().split('_');
                    return `status.${words[0]}${words.slice(1).map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('')}`;
                  };

                  const statusKey = formatStatusKey(complaint.status);
                  const priorityKey = complaint.priority ? `priority.${complaint.priority}` : '';
                  const raisedByKey = complaint.raisedBy ? `raisedBy.${complaint.raisedBy.toLowerCase()}` : '';

                  return (
                    <tr
                      key={complaint.complaintId}
                      className={`border-b border-gray-50 transition-colors ${complaint.raisedBy === "COLLECTOR"
                        ? "bg-purple-100 hover:bg-purple-150 border-l-4 border-purple-600 shadow-sm"
                        : "hover:bg-gray-50/50"
                        }`}
                    >
                      <td
                        className="cursor-pointer px-8 py-6 text-sm font-semibold"
                        onClick={() => handleViewDetails(complaint)}
                      >
                        <div className="flex items-center gap-2">
                          {complaint.raisedBy === "COLLECTOR" && (
                            <span className="font-bold text-purple-700">★</span>
                          )}
                          <span className={complaint.raisedBy === "COLLECTOR" ? "text-purple-700 font-bold" : "text-blue-700"}>
                            {complaint.complaintId || t('common.na')}
                          </span>
                        </div>
                      </td>

                      <td className="px-8 py-6 text-sm text-gray-600">
                        {formatNumberForLanguage(complaint.submittedDate || t('common.na'), currentLanguage)}
                      </td>

                      <td className="px-8 py-6 text-sm text-gray-600">
                        {complaint.status === "RESOLVED"
                          ? formatNumberForLanguage(complaint.resolvedDate || t('common.na'), currentLanguage)
                          : t('common.na')
                        }
                      </td>

                      <td className="px-8 py-6">
                        <div className="text-sm font-semibold text-gray-900">
                          <TranslatedText>{complaint.name || t('common.na')}</TranslatedText>
                        </div>
                        <div className="mt-1 text-sm text-gray-500">
                          {formatNumberForLanguage(complaint.mobile || t('common.na'), currentLanguage)}
                        </div>
                        <div className="text-sm text-gray-500">
                          <TranslatedText>{complaint.village || t('common.na')}</TranslatedText>
                        </div>
                      </td>

                      <td className="px-8 py-6">
                        <span className={`inline-flex px-3 py-2 text-xs font-semibold rounded-full whitespace-nowrap ${getPriorityColor(complaint.priority)}`}>
                          <TranslatedText>{priorityKey}</TranslatedText>
                        </span>
                      </td>

                      <td className="px-8 py-6 text-sm text-gray-600">
                        <TranslatedText>{t(`taluka.${complaint.taluka}`, { defaultValue: complaint.taluka }) || t('common.na')}</TranslatedText>
                      </td>

                      <td className="px-8 py-6 text-sm text-gray-600">
                        <TranslatedText>{t(`department.${complaint.departmentName}`, { defaultValue: complaint.departmentName }) || t('common.na')}</TranslatedText>
                      </td>

                      <td className="px-8 py-6">
                        <span className={`inline-flex px-3 py-2 text-xs font-semibold rounded-full whitespace-nowrap ${getStatusColor(complaint.status)}`}>
                          <TranslatedText>{statusKey}</TranslatedText>
                        </span>
                      </td>

                      <td className="items-center justify-center px-8 py-6">
                        <span className={`px-3 py-2 text-xs font-semibold rounded-full ${getPendingDaysStatusColor(
                          complaint.pendingDays !== undefined
                            ? complaint.pendingDays
                            : complaint.pendingDay || complaint.PendingDays
                        )}`}>
                          {formatNumberForLanguage(
                            complaint.pendingDays !== undefined
                              ? complaint.pendingDays
                              : complaint.pendingDay || complaint.PendingDays || t('common.na'),
                            currentLanguage
                          )}
                        </span>
                      </td>

                      <td className="px-8 py-6">
                        <span className={`inline-flex px-3 py-2 text-xs font-bold rounded-full ${complaint.raisedBy === "COLLECTOR"
                          ? "bg-purple-600 text-white"
                          : "bg-gray-100 text-green-800"
                          }`}>
                          <TranslatedText>{raisedByKey}</TranslatedText>
                        </span>
                      </td>

                      <td className="px-8 py-6">
                        <button
                          onClick={() => handleAssignClick(complaint)}
                          disabled={
                            complaint.status === 'Resolved' ||
                            complaint.status === 'RESOLVED' ||
                            complaint.status === 'Rejected' ||
                            complaint.status === 'REJECTED'
                          }
                          className={`inline-flex items-center px-4 py-2 text-sm font-medium rounded-lg transition-colors border ${complaint.status === 'Resolved' ||
                            complaint.status === 'RESOLVED' ||
                            complaint.status === 'Rejected' ||
                            complaint.status === 'REJECTED'
                            ? 'text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed'
                            : 'text-orange-700 hover:text-orange-800 hover:bg-orange-50 border-orange-200'
                            }`}
                        >
                          <UserCheck className="mr-2 h-4 w-4" />
                          {complaint.departmentName !== departmentName
                            ? t('actions.assigned')
                            : t('actions.assign')
                          }
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>

            </table>
          </div>
          {/* Pagination */}
          {totalPages > 1 && (
            <div className="border-t border-gray-200 bg-gray-50 px-6 py-4">
              <div className="flex items-center justify-between">
                <div className="text-sm text-gray-700">
                  {currentLanguage === 'mr' ? `पृष्ठ ${formatNumberForLanguage(currentPage, currentLanguage)} च ${formatNumberForLanguage(totalPages, currentLanguage)} (${formatNumberForLanguage(totalComplaints, currentLanguage)} तक्रार)` : `Page ${formatNumberForLanguage(currentPage, currentLanguage)} of ${formatNumberForLanguage(totalPages, currentLanguage)} (${formatNumberForLanguage(totalComplaints, currentLanguage)} complaints)`}
                </div>
                <div className="flex items-center gap-2">
                  {/* First Page */}
                  <button
                    onClick={goToFirstPage}
                    disabled={currentPage === 1}
                    className="rounded border border-gray-300 px-3 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {t('pagination.first')}
                  </button>

                  {/* Previous Page */}
                  <button
                    onClick={goToPreviousPage}
                    disabled={currentPage === 1}
                    className="flex items-center rounded border border-gray-300 px-2 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    <ChevronLeft className="h-4 w-4" />
                  </button>

                  {/* Page Numbers */}
                  <div className="flex items-center gap-1">
                    {(() => {
                      const pages = [];
                      const showPages = 5; // Show 5 page numbers at most
                      let startPage = Math.max(1, currentPage - 2);
                      let endPage = Math.min(
                        totalPages,
                        startPage + showPages - 1
                      );

                      // Adjust start if we're near the end
                      if (endPage - startPage < showPages - 1) {
                        startPage = Math.max(1, endPage - showPages + 1);
                      }

                      // Add ellipsis at start
                      if (startPage > 1) {
                        pages.push(
                          <button
                            key={1}
                            onClick={() => goToPage(1)}
                            className={`px-3 py-1 border rounded text-sm ${currentPage === 1 ? 'bg-yellow-600 text-white border-yellow-600' : 'border-gray-300 hover:bg-gray-100'}`}
                          >
                            {formatNumberForLanguage(1, currentLanguage)}
                          </button>
                        );
                        if (startPage > 2) {
                          pages.push(
                            <span
                              key="start-ellipsis"
                              className="px-2 text-gray-500"
                            >
                              ...
                            </span>
                          );
                        }
                      }

                      // Add page numbers
                      for (let i = startPage; i <= endPage; i++) {
                        pages.push(
                          <button
                            key={i}
                            onClick={() => goToPage(i)}
                            className={`px-3 py-1 border rounded text-sm ${currentPage === i ? 'bg-yellow-600 text-white border-yellow-600' : 'border-gray-300 hover:bg-gray-100'}`}
                          >
                            {formatNumberForLanguage(i, currentLanguage)}
                          </button>
                        );
                      }

                      // Add ellipsis at end
                      if (endPage < totalPages) {
                        if (endPage < totalPages - 1) {
                          pages.push(
                            <span
                              key="end-ellipsis"
                              className="px-2 text-gray-500"
                            >
                              ...
                            </span>
                          );
                        }
                        pages.push(
                          <button
                            key={totalPages}
                            onClick={() => goToPage(totalPages)}
                            className={`px-3 py-1 border rounded text-sm ${currentPage === totalPages ? 'bg-yellow-600 text-white border-yellow-600' : 'border-gray-300 hover:bg-gray-100'}`}
                          >
                            {formatNumberForLanguage(totalPages, currentLanguage)}
                          </button>
                        );
                      }

                      return pages;
                    })()}
                  </div>

                  {/* Next Page */}
                  <button
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                    className="flex items-center rounded border border-gray-300 px-2 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    <ChevronRight className="h-4 w-4" />
                  </button>

                  {/* Last Page */}
                  <button
                    onClick={goToLastPage}
                    disabled={currentPage === totalPages}
                    className="rounded border border-gray-300 px-3 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                  >
                    {t('pagination.last')}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Enhanced Professional Modal */}
        {showDetailModal && selectedComplaint && (
          <div className="fixed inset-0 z-[9999] flex h-full w-full items-center justify-center overflow-y-auto bg-black bg-opacity-50 p-4 backdrop-blur-sm">
            <div className="bg-white rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
              {/* Professional Header */}
              <div className="rounded-t-lg border-b border-gray-200 bg-gray-50 px-4 py-4 sm:rounded-t-none md:px-6">
                <div className="flex items-center justify-between">
                  {/* Left section */}
                  <div className="flex items-center space-x-4">
                    <button
                      onClick={handleCloseModal}
                      className="text-gray-400 hover:text-gray-600"
                    >
                      <svg
                        className="h-5 w-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M15 19l-7-7 7-7"
                        />
                      </svg>
                    </button>
                    <p className="text-sm text-gray-500"><TranslatedText>Complaint Details</TranslatedText></p>
                  </div>

                  {/* Right section */}
                  <div className="flex items-center space-x-3">
                    <button
                      onClick={handlePrint}
                      className="flex items-center rounded-md bg-gray-600 px-3 py-2 text-sm font-medium text-white transition hover:bg-gray-700"
                    >
                      <Printer className="mr-2 h-4 w-4" />
                      <TranslatedText>  Print </TranslatedText>
                    </button>
                    <button
                      onClick={handleCloseModal}
                      className="rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
                    >
                      <svg
                        className="h-5 w-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Complaint Header */}
              <div className="border-b border-gray-200 px-4 py-4 md:px-6">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <h2 className="text-xl font-semibold text-gray-900">
                      {selectedComplaint.complaintId || 'Complaint Details'}
                    </h2>
                    <div className="mt-2 flex items-center space-x-4">
                      <span className="text-sm text-gray-500">
                        <TranslatedText>{formatNumberForLanguage(selectedComplaint.submittedDate, currentLanguage)}</TranslatedText>
                      </span>
                      <span
                        className={`inline-flex px-4 py-2 text-sm font-semibold whitespace-nowrap rounded-full  ${getStatusColor(selectedComplaint.status)}`}
                      >
                        <TranslatedText>{formatStatus(selectedComplaint.status)}</TranslatedText>
                      </span>
                      <div className="flex items-center gap-2">
                        <label
                          htmlFor="priority"
                          className="text-sm font-medium text-gray-700"
                        >
                          <TranslatedText>Priority:</TranslatedText>
                        </label>

                        <div className="relative">
                          <select
                            id="priority"
                            value={selectedComplaint.priority || 'MEDIUM'}
                            onChange={(e) =>
                              handlePriorityUpdate(
                                selectedComplaint.id,
                                e.target.value
                              )
                            }
                            className={`text-sm font-semibold rounded-full px-4 py-1.5 border shadow-sm transition-all duration-300 appearance-none focus:outline-none pr-10 cursor-pointer w-full bg-transparent
        ${selectedComplaint.priority === 'HIGH'
                                ? 'bg-red-100 text-red-700 border-red-300 focus:ring-2 focus:ring-red-400'
                                : selectedComplaint.priority === 'LOW'
                                  ? 'bg-green-100 text-green-700 border-green-300 focus:ring-2 focus:ring-green-400'
                                  : 'bg-yellow-100 text-yellow-700 border-yellow-300 focus:ring-2 focus:ring-yellow-400'
                              }`}
                          >
                            <option value="LOW" className="text-green-700">{t('priority.LOW')}</option>
                            <option value="MEDIUM" className="text-yellow-700">{t('priority.MEDIUM')}</option>
                            <option value="HIGH" className="text-red-700">{t('priority.HIGH')}</option>
                          </select>

                          {/* Custom dropdown arrow - make sure this is the ONLY arrow */}
                          <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center text-gray-700">
                            <svg
                              className="h-4 w-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M19 9l-7 7-7-7"
                              />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Status Progress */}
              <div className="border-b border-gray-200 px-4 py-4 md:px-6">
                <div className="mb-2 flex items-center justify-between">
                  <span
                    className={`px-2 py-1 text-sm font-medium whitespace-nowrap rounded ${selectedComplaint.status === 'In Progress'
                      ? 'bg-blue-100 text-blue-800'
                      : 'bg-gray-100 text-gray-800'
                      }`}
                  >
                    {t(`status.${selectedComplaint.status}`) || selectedComplaint.status}
                  </span>
                  <span className="text-sm text-gray-500">
                    <TranslatedText>Updated</TranslatedText>
                    <TranslatedText>{selectedComplaint.submittedDate}</TranslatedText>
                  </span>
                </div>
                <div className="h-2 w-full rounded-full bg-gray-200">
                  <div
                    className={`h-2 rounded-full ${selectedComplaint.status === 'New Status'
                      ? 'w-[5%] bg-blue-500'
                      : selectedComplaint.status === 'In Progress'
                        ? 'w-1/2 bg-blue-500'
                        : selectedComplaint.status === 'Resolved' ||
                          selectedComplaint.status === 'RESOLVED'
                          ? 'w-full bg-green-500'
                          : selectedComplaint.status === 'Rejected'
                            ? 'w-full bg-red-500'
                            : 'w-[5%] bg-blue-500'
                      }`}
                  ></div>
                </div>
                <div className="mt-2 grid grid-cols-3 text-xs text-gray-500">
                  <span
                    className={`text-left ${selectedComplaint.status === 'Submitted' ||
                      selectedComplaint.status === 'In Progress' ||
                      selectedComplaint.status === 'Resolved' ||
                      selectedComplaint.status === 'RESOLVED'
                      ? 'text-blue-600 font-medium'
                      : ''
                      }`}
                  >
                    ✓ <TranslatedText> Acknowledged</TranslatedText>
                  </span>
                  <span
                    className={`text-center ${selectedComplaint.status === 'In Progress' ||
                      selectedComplaint.status === 'Resolved' ||
                      selectedComplaint.status === 'RESOLVED'
                      ? 'text-blue-600 font-medium'
                      : ''
                      }`}
                  >
                    {selectedComplaint.status === 'In Progress' ||
                      selectedComplaint.status === 'Resolved' ||
                      selectedComplaint.status === 'RESOLVED'
                      ? '✓'
                      : '◯'}{' '}
                    {t('dashboard.stats.progress')}
                  </span>
                  <span
                    className={`text-right ${selectedComplaint.status === 'Resolved' ||
                      selectedComplaint.status === 'RESOLVED'
                      ? 'text-green-600 font-medium'
                      : ''
                      }`}
                  >
                    {selectedComplaint.status === 'Resolved' ||
                      selectedComplaint.status === 'RESOLVED'
                      ? '✓'
                      : '◯'}{' '}
                    {t('dashboard.stats.resolved')}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="space-y-4">
                  <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
                    <div className="rounded-xl border border-gray-200 bg-gradient-to-br from-slate-50 to-gray-100 p-6">
                      <h3
                        className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900"
                        style={{ color: '#B8860B' }}
                      >
                        <span
                          className="h-2 w-2 rounded-full"
                          style={{ backgroundColor: '#B8860B' }}
                        ></span>
                        {t('modal.complaintInfo')}
                      </h3>
                      <div className="space-y-3 text-sm">
                        <p>
                          <span className="font-medium text-gray-700">
                            {t('track.details.name')}:
                          </span>{' '}
                          <span className="text-gray-900">
                            <TranslatedText>{selectedComplaint.name}</TranslatedText>
                          </span>
                        </p>
                        <p>
                          <span className="font-medium text-gray-700">
                            {t('track.details.mobile')}:
                          </span>{' '}
                          <span className="text-gray-900">
                            {formatNumberForLanguage(selectedComplaint.mobile, currentLanguage)}
                          </span>
                        </p>
                        <div className="flex items-start gap-2">
                          <span className="font-medium text-gray-700"> {t('track.details.address')}:</span>
                          <div className="scrollbar-thin max-h-28 overflow-y-auto break-words leading-relaxed text-gray-900">
                            <TranslatedText>{selectedComplaint.address}</TranslatedText>
                          </div>
                        </div>

                        <p>
                          <span className="font-medium text-gray-700">
                            {t('track.details.village')}:
                          </span>{' '}
                          <span className="text-gray-900">
                            <TranslatedText>{selectedComplaint.village}</TranslatedText>
                          </span>
                        </p>
                        <p>
                          <span className="font-medium text-gray-700">
                            {t('track.details.taluka')}:
                          </span>{' '}
                          <span className="text-gray-900">
                            <TranslatedText>{selectedComplaint.taluka}</TranslatedText>
                          </span>
                        </p>
                      </div>
                    </div>

                    <div className="rounded-xl border border-gray-200 bg-gradient-to-br from-slate-50 to-gray-100 p-6">
                      <h3
                        className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900"
                        style={{ color: '#B8860B' }}
                      >
                        <span
                          className="h-2 w-2 rounded-full"
                          style={{ backgroundColor: '#B8860B' }}
                        ></span>
                        {t('modal.complaintInfo')}
                      </h3>
                      <div className="space-y-3 text-sm">
                        <p>
                          <span className="font-medium text-gray-700">
                            {t('track.Submitted Date')}:
                          </span>{' '}
                          <span className="text-gray-900">
                            <TranslatedText>  {formatNumberForLanguage(selectedComplaint.submittedDate, currentLanguage)}</TranslatedText>
                          </span>
                        </p>
                        <p>
                          <span className="font-medium text-gray-700">
                            {t('track.Assigned To')}:
                          </span>{' '}
                          <span className="text-gray-900">
                            <TranslatedText>{selectedComplaint.assignedTo}</TranslatedText>
                          </span>
                        </p>


                        <span className="font-medium text-gray-700">
                          {t('dashboard.table.priority')}:
                        </span>{' '}
                        <span
                          className={`px-2 py-1 rounded-full text-xs font-semibold
    ${selectedComplaint.priority === "HIGH"
                              ? "bg-red-100 text-red-700"
                              : selectedComplaint.priority === "LOW"
                                ? "bg-green-100 text-green-700"
                                : "bg-yellow-100 text-yellow-700"
                            }`}
                        >
                          <TranslatedText>{'priority.' + selectedComplaint.priority}</TranslatedText>
                        </span>

                      </div>
                    </div>
                  </div>

                  {/* Complaint Description */}
                  <div className="rounded-lg bg-white shadow">
                    <div className="word-wrap-300 border-b border-gray-200 px-6 py-4">
                      <h3 className="word-wrap-300 text-lg font-semibold text-gray-900">
                        <TranslatedText>Complaint Description</TranslatedText>
                      </h3>
                    </div>
                    <div className="p-6">
                      <div className="max-h-48 overflow-y-auto rounded-xl border border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50 p-4">
                        <p className="whitespace-pre-wrap break-all leading-relaxed text-gray-800">
                          <TranslatedText>{selectedComplaint.description ||
                            "No description available for this complaint."}</TranslatedText>
                        </p>
                      </div>
                    </div>
                  </div>



                  {/* Officer Notes */}
                  {selectedComplaint.officerNotes && (
                    <div className="rounded-lg bg-white shadow">
                      <div className="border-b border-gray-200 px-6 py-4">
                        <h3 className="text-lg font-semibold text-gray-900">
                          <TranslatedText>Officer Notes</TranslatedText>
                        </h3>
                      </div>
                      <div className="p-6">
                        <div
                          className="rounded-r-xl border-l-4 bg-gradient-to-br from-yellow-50 to-amber-50 p-4"
                          style={{ borderLeftColor: '#B8860B' }}
                        >
                          {/* ✅ Clean wrapping + scrollable area */}
                          <div className="max-h-64 space-y-4 overflow-y-auto">
                            <p className="whitespace-pre-wrap break-words leading-relaxed text-gray-800">
                              <TranslatedText>{selectedComplaint.officerNotes}</TranslatedText>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="rounded-lg bg-white shadow">
                    <div className="border-b border-gray-200 px-6 py-4">
                      <div className="flex items-center justify-between">
                        <h3 className="text-lg font-semibold text-gray-900">
                          <TranslatedText>Citizen Photos</TranslatedText>
                        </h3>
                        <span className="rounded bg-blue-50 px-2 py-1 text-sm text-blue-600">
                          ✓ <TranslatedText>Submitted</TranslatedText>
                        </span>
                      </div>
                    </div>
                    <div className="p-6">
                      <div className="max-h-96 space-y-3 overflow-y-auto break-all">
                        {selectedComplaint.attachments_citizen &&
                          selectedComplaint.attachments_citizen.length > 0 ? (
                          selectedComplaint.attachments_citizen.map(
                            (attachment, index) => (
                              <div
                                key={index}
                                className="rounded-lg border border-gray-200 p-3"
                              >
                                <div className="flex items-center justify-between">
                                  <div className="flex items-center space-x-3">
                                    <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
                                      <Image className="h-5 w-5 text-blue-600" />
                                    </div>
                                    <div>
                                      <p className="text-sm font-medium text-gray-900">
                                        {`Citizen-${selectedComplaint.complaintId}-${index + 1}` ||
                                          `citizen_photo_${index + 1}.jpg`}
                                      </p>
                                      <p className="text-xs text-gray-500">
                                        {formatFileSizeWithLanguage(attachment.size)}{' '}
                                        • <TranslatedText>Uploaded by citizen</TranslatedText>
                                        {attachment.uploadedDate &&
                                          ` on ${new Date(attachment.uploadedDate).toLocaleDateString()}`}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex gap-2">
                                    <button
                                      onClick={() =>
                                        handleViewImage(
                                          attachment,
                                          selectedComplaint.complaintId,
                                          false
                                        )
                                      }
                                      className="flex items-center gap-1 rounded px-3 py-1 text-sm font-medium text-blue-600 hover:bg-blue-50 hover:text-blue-800"
                                    >
                                      <Eye className="h-4 w-4" />
                                      {t('dashboard.modal.view')}
                                    </button>
                                    <button
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDownloadFromModal(attachment);
                                      }}
                                      className="flex items-center gap-1 rounded px-3 py-1 text-sm font-medium text-blue-600 hover:bg-blue-50 hover:text-blue-800"
                                    >
                                      <Download className="h-4 w-4" />
                                      <TranslatedText>Download</TranslatedText>
                                    </button>

                                  </div>
                                </div>
                              </div>
                            )
                          )
                        ) : (
                          <div className="py-6 text-center">
                            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-lg bg-gray-100">
                              <Image className="h-6 w-6 text-gray-400" />
                            </div>
                            <p className="text-sm text-gray-500">
                              {t('dashboard.modal.noPhotos')}
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Officer Resolution Photos - Only show if resolved */}
                  {
                    <div className="rounded-lg bg-white shadow">
                      <div className="border-b border-gray-200 px-6 py-4">
                        <div className="flex items-center justify-between">
                          <h3 className="text-lg font-semibold text-gray-900">
                            <TranslatedText>Officer Resolution Photos</TranslatedText>
                          </h3>
                          <span className="rounded bg-green-50 px-2 py-1 text-sm text-green-600">
                            ✓ <TranslatedText>Resolution Evidence</TranslatedText>
                          </span>
                        </div>
                      </div>
                      <div className="p-6">
                        <div className="max-h-96 space-y-3 overflow-y-auto break-all">
                          {selectedComplaint.attachments_officer &&
                            selectedComplaint.attachments_officer.length > 0 ? (
                            selectedComplaint.attachments_officer.map(
                              (attachment, index) => (
                                <div
                                  key={index}
                                  className="rounded-lg border border-gray-200 bg-green-50 p-3"
                                >
                                  <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-3">
                                      <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-green-100">
                                        <Image className="h-5 w-5 text-green-600" />
                                      </div>
                                      <div>
                                        <p className="text-sm font-medium text-gray-900">
                                          {`Officer-${selectedComplaint.complaintId}-${index + 1}` ||
                                            `resolution_photo_${index + 1}.jpg`}
                                        </p>
                                        <p className="text-xs text-gray-500">
                                          {formatFileSizeWithLanguage(attachment.size)}{' '}
                                          • <TranslatedText>Uploaded by Officer</TranslatedText>
                                          {attachment.uploadedDate &&
                                            ` on ${new Date(attachment.uploadedDate).toLocaleDateString()}`}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="flex gap-2">
                                      <button
                                        onClick={() =>
                                          handleViewImage(
                                            attachment,
                                            selectedComplaint.complaintId,
                                            true
                                          )
                                        }
                                        className="flex items-center gap-1 rounded px-3 py-1 text-sm font-medium text-green-600 hover:bg-green-100 hover:text-green-800"
                                      >
                                        <Eye className="h-4 w-4" />
                                        {t('dashboard.modal.view')}
                                      </button>
                                      <button
                                        onClick={async () => {
                                          try {
                                            const endpoint =
                                              normalizeAttachmentEndpoint(
                                                attachment.url ||
                                                attachment.fileUrl ||
                                                attachment.path
                                              );
                                            if (!endpoint) {
                                              alert(
                                                'Error downloading attachment'
                                              );
                                              return;
                                            }
                                            const blob =
                                              await ApiService.getBlob(
                                                endpoint
                                              );
                                            const objectUrl =
                                              URL.createObjectURL(blob);
                                            const ext =
                                              attachment.fileType &&
                                                attachment.fileType.includes('/')
                                                ? attachment.fileType.split(
                                                  '/'
                                                )[1]
                                                : 'bin';
                                            const filename = `${selectedComplaint.complaintId}_resolution.${ext}`;

                                            const link =
                                              document.createElement('a');
                                            link.href = objectUrl;
                                            link.download = filename;
                                            document.body.appendChild(link);
                                            link.click();
                                            document.body.removeChild(link);
                                            URL.revokeObjectURL(objectUrl);
                                          } catch (error) {
                                            console.error(
                                              'Error downloading attachment:',
                                              error
                                            );
                                            alert(
                                              'Error downloading attachment'
                                            );
                                          }
                                        }}
                                        className="flex items-center gap-1 rounded px-3 py-1 text-sm font-medium text-green-600 hover:bg-green-100 hover:text-green-800"
                                      >
                                        <Download className="h-4 w-4" />
                                        <TranslatedText>Download</TranslatedText>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )
                            )
                          ) : (
                            <div className="py-6 text-center">
                              <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-lg bg-gray-100">
                                <Image className="h-6 w-6 text-gray-400" />
                              </div>
                              <p className="text-sm text-gray-500">
                                <TranslatedText>No resolution photos uploaded by officer</TranslatedText>
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  }

                  {/* Action Timeline */}
                  <div className="rounded-lg bg-white shadow">
                    <div className="border-b border-gray-200 px-6 py-4">
                      <h3 className="text-lg font-semibold text-gray-900">
                        {t('admin.modal.actionTimeline')}
                      </h3>
                    </div>

                    <div className="rounded-b-lg bg-gradient-to-br from-green-50 to-emerald-50 p-6">
                      <div className="max-h-48 space-y-3 overflow-y-auto">
                        {Array.isArray(selectedComplaint.timeline) &&
                          selectedComplaint.timeline.length > 0 ? (
                          selectedComplaint.timeline.map((event, index) => {
                            // Helper function to get meaningful action description

                            const getActionDescription = (event) => {
                              if (
                                event.action === 'STATUS_UPDATE' &&
                                event.note
                              ) {
                                if (event.note.includes('status changed'))
                                  return event.note;
                                if (event.note.includes('Status updated'))
                                  return event.note;
                                return `Status updated: ${event.note}`;
                              }

                              const actionMap = {
                                STATUS_UPDATE: t('Status Updated'),
                                COMPLAINT_SUBMITTED: t('Complaint Submitted'),
                                COMPLAINT_ASSIGNED: t('Complaint Assigned'),
                                COMPLAINT_RESOLVED: t('Complaint Resolved'),
                                COMPLAINT_REJECTED: t('Complaint Rejected'),
                                COMMENT_ADDED: t('Comment Added'),
                                DOCUMENT_UPLOADED: t('Document Uploaded'),
                              };

                              return (
                                actionMap[event.action] ||
                                event.action ||
                                'Action Taken'
                              );
                            };

                            const getOfficerInfo = (event) => {
                              if (
                                event.officer &&
                                event.officer !== 'N/A' &&
                                event.officer !== ''
                              )
                                return event.officer;
                              if (event.updatedBy) return event.updatedBy;
                              if (event.assignedTo) return event.assignedTo;
                              return 'System';
                            };

                            return (
                              <div key={index} className="flex items-start">
                                <div className="flex items-center">
                                  <div
                                    className="h-3 w-3 rounded-full"
                                    style={{ backgroundColor: '#B8860B' }}
                                  ></div>
                                  {index <
                                    selectedComplaint.timeline.length - 1 && (
                                      <div
                                        className="w-px h-8 ml-1.5 mt-1"
                                        style={{ backgroundColor: '#B8860B' }}
                                      ></div>
                                    )}
                                </div>

                                <div className="ml-3 flex-1">
                                  <div className="rounded-lg border border-green-200 bg-white p-3">
                                    <div className="flex items-start justify-between">
                                      <div className="mr-3 flex-1">
                                        <h4 className="mb-1 text-sm font-semibold text-gray-900">
                                          <TranslatedText>{getActionDescription(event)}</TranslatedText>
                                        </h4>


                                        {/* ✅ Added scrollable + breakable text container */}
                                        <div className="max-h-64 w-full space-y-2 overflow-y-auto md:w-full lg:w-full">
                                          {event.description && (
                                            <p className="mb-1 break-words text-xs text-gray-700">
                                              <TranslatedText> {event.description} </TranslatedText>
                                            </p>
                                          )}
                                          {event.note && event.action !== 'STATUS_UPDATE' && (
                                            <p className="mb-1 break-words text-xs text-gray-700">
                                              <TranslatedText> {event.note}</TranslatedText>
                                            </p>
                                          )}
                                        </div>

                                        <p
                                          className="mt-1 text-xs font-medium"
                                          style={{ color: '#B8860B' }}
                                        >
                                          {/* <TranslatedText>  By:</TranslatedText>
                                        <TranslatedText> {getOfficerInfo(event)} </TranslatedText> */}
                                          <TranslatedText>By:</TranslatedText>
                                          <TranslatedText>{event.officerName || 'Citizen'}</TranslatedText>
                                        </p>
                                      </div>

                                      <div className="whitespace-nowrap text-xs text-gray-500">
                                        {formatNumberForLanguage(event.date || event.timestamp || event.createdAt, currentLanguage)}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        ) : (
                          <p className="py-4 text-center text-sm text-gray-600">
                            <TranslatedText>No timeline available</TranslatedText>
                          </p>
                        )
                        }

                      </div>
                    </div>
                  </div>

                  {/* Comments Section */}
                  <div className="rounded-lg bg-white shadow">
                    <div className="border-b border-gray-200 px-6 py-4">
                      <h3 className="text-lg font-semibold text-gray-900">
                        <TranslatedText>Comments & Updates</TranslatedText>
                      </h3>
                    </div>

                    <div className="p-6">
                      <div className="mb-4 max-h-40 space-y-3 overflow-y-auto">
                        {[...comments].reverse().map((comment) => (
                          <div
                            key={comment.id}
                            className="flex items-start space-x-3"
                          >
                            <div
                              className={`w-6 h-6 rounded-full flex items-center justify-center ${comment.visibility === 'PUBLIC'
                                ? 'bg-green-100'
                                : 'bg-orange-100'
                                }`}
                            >
                              <span
                                className={`text-xs font-semibold ${comment.visibility === 'PUBLIC'
                                  ? 'text-green-600'
                                  : 'text-orange-600'
                                  }`}
                              >
                                {comment.visibility === 'PUBLIC' ? 'P' : 'I'}
                              </span>
                            </div>

                            <div className="min-w-0 flex-1">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center space-x-2">
                                  <p className="text-sm font-medium text-gray-900">
                                    <TranslatedText>{comment.commentBy}</TranslatedText>
                                  </p>
                                  <span
                                    className={`text-xs px-2 py-1 rounded-full ${comment.visibility.toLowerCase() ===
                                      'public'
                                      ? 'bg-green-100 text-green-700'
                                      : 'bg-orange-100 text-orange-700'
                                      }`}
                                  >
                                    {comment.visibility === 'PUBLIC'
                                      ? t('Public')
                                      : t('Internal')}
                                  </span>
                                </div>
                                <span className="text-xs text-gray-500">{formatNumberForLanguage(comment.createdAt, currentLanguage)}</span>
                              </div>

                              {/* ✅ Fixed text wrapping + spacing */}
                              <p className="mt-1 max-h-20 overflow-y-auto whitespace-pre-wrap break-words text-sm leading-relaxed text-gray-700">
                                <TranslatedText>{comment.comment}</TranslatedText>

                              </p>
                            </div>
                          </div>
                        ))}

                        {comments.length === 0 && (
                          <div className="py-4 text-center">
                            <MessageCircle className="mx-auto mb-2 h-8 w-8 text-gray-300" />
                            <p className="text-sm font-medium text-gray-900"> <TranslatedText>No comments yet</TranslatedText></p>
                            <p className="text-xs text-gray-500"> <TranslatedText>Add the first comment</TranslatedText></p>
                          </div>
                        )}
                      </div>

                      <div className="border-t border-gray-200 pt-4">
                        <div className="mb-3 flex items-center gap-3">
                          <button
                            onClick={() => setCommentType('PUBLIC')}
                            className={`inline-flex items-center px-3 py-1 rounded-lg text-xs font-medium transition-all ${commentType === 'PUBLIC'
                              ? 'bg-green-100 text-green-800'
                              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                              }`}
                          >
                            <TranslatedText>Public</TranslatedText>
                          </button>
                          <button
                            onClick={() => setCommentType('INTERNAL')}
                            className={`inline-flex items-center px-3 py-1 rounded-lg text-xs font-medium transition-all ${commentType === 'INTERNAL'
                              ? 'bg-orange-100 text-orange-800'
                              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                              }`}
                          >
                            <TranslatedText>Internal</TranslatedText>
                          </button>
                        </div>

                        <div className="flex gap-2">

                          <textarea
                            value={newComment}
                            onChange={(e) => setNewComment(e.target.value)}
                            placeholder={commentType === 'PUBLIC' ? t('dashboard.comments.addPublicComment') : t('dashboard.comments.addInternalComment')}
                            className="flex-1 resize-none rounded-lg border border-gray-300 p-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                            rows="2"
                          />

                          <button
                            onClick={handleAddComment}
                            disabled={!newComment.trim()}
                            className={`px-4 py-2 text-white text-sm font-medium rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed ${commentType === 'PUBLIC'
                              ? 'bg-green-600 hover:bg-green-700'
                              : 'bg-orange-600 hover:bg-orange-700'
                              }`}
                          >
                            <TranslatedText>Post</TranslatedText>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Assign Complaint Modal */}
        {showAssignModal && assignComplaint && (
          <AssignComplaintPage
            complaint={assignComplaint}
            onClose={handleAssignClose}
            onAssignSuccess={handleAssign}
          />
        )}

        {/* Charts Row 1 */}
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
          {/* Taluka-wise Complaints Bar Chart */}
          <div className="rounded-2xl border border-gray-100 bg-white p-8 shadow-lg">
            <div className="mb-6 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">
                <TranslatedText> Taluka-Wise Status  </TranslatedText>
              </h3>

            </div>
            <div className="h-80">
              <TranslatedText><Bar data={talukaBarChartData} options={chartOptions} /></TranslatedText>
            </div>
          </div>

          {/* Category Distribution Doughnut Chart */}
          {/* <div className="mb-8 grid h-full w-full grid-cols-1 gap-6 md:grid-cols-2">          */}
          <div className="rounded-2xl border border-gray-100 bg-white p-8 shadow-lg">
            <div className="mb-6 flex items-center justify-between">
              <h3 className="text-xl font-bold text-gray-900">
                <TranslatedText>Complaints By Department</TranslatedText>
              </h3>
              {/* <button className="rounded-lg px-3 py-1 text-sm font-medium text-blue-600 transition-colors hover:bg-blue-50 hover:text-blue-800">View Details</button> */}
            </div>
            <div className="flex h-80 justify-center">
              <TranslatedText>  <Doughnut data={categoryDoughnutData} options={chartOptions} /></TranslatedText>
            </div>
          </div>
          {/* </div> */}
        </div>


        {/* Section 2: NEW HEATMAPS SECTION */}

        <div className="mb-8 grid h-full w-full grid-cols-1 gap-6 md:grid-cols-2">
          {/* Looker Studio Geographic Map */}

          <div className="col-span-1 w-full md:col-span-2 flex h-full flex-col rounded-xl border bg-white p-4 shadow">
            <h3 className="mb-4 text-center font-bold">
              <TranslatedText>Geographic Complaint Heatmap</TranslatedText>

            </h3>
            <div className="w-full">
              <iframe
                width="100%"
                height="450"
                src="https://lookerstudio.google.com/embed/reporting/02b490b8-d503-4cd3-88f7-25bc31592450/page/xXxmF"
                frameBorder="0"
                style={{ border: 0 }}
                allowFullScreen
                sandbox="allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                className="w-full h-[450px] border-0 rounded-[15px]" />
            </div>
          </div>




          {/* Remove items-center and justify-center to allow content to expand */}
          {/* <div className="flex h-full w-full flex-col rounded-xl border bg-white p-4 shadow">
            <h3 className="mb-4 text-center font-bold">
              <TranslatedText>Live Gadchiroli Hits</TranslatedText>
            </h3>
            <div className="w-full">
              <InteractionMap />
            </div>
          </div> */}

          {/* Complaint Statistics (Home-style, English labels) */}
          <div className="col-span-1 w-full md:col-span-2">
            <div className="mt-8 rounded-xl border border-gray-200 bg-white/95 px-6 py-8 shadow-lg backdrop-blur-sm">
              <div className="mb-8 text-center">
                <h2 className="mb-2 text-xl font-bold text-gray-900 sm:text-2xl">
                  <TranslatedText>Complaint Statistics</TranslatedText>
                </h2>
                <div
                  className="mx-auto h-1 w-16 rounded-full"
                  style={{ backgroundColor: '#B8860B' }}
                ></div>
              </div>

              <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                <div className="relative rounded-2xl border-2 border-orange-200 bg-gradient-to-br from-orange-50 to-yellow-50 p-8 text-center shadow-lg transition-all duration-300 hover:shadow-xl">
                  <div
                    className="absolute right-4 top-4 flex h-12 w-12 items-center justify-center rounded-full"
                    style={{ backgroundColor: 'rgba(184, 134, 11, 0.1)' }}
                  >
                    <svg
                      className="h-6 w-6"
                      style={{ color: '#B8860B' }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  </div>
                  {publicStats.loading ? (
                    <div className="animate-pulse">
                      <div className="mx-auto mb-3 h-12 w-24 rounded bg-gray-200"></div>
                      <div className="mx-auto h-4 w-32 rounded bg-gray-200"></div>
                    </div>
                  ) : (
                    <>
                      <h3 className="mb-3 text-4xl font-bold" style={{ color: '#B8860B' }}>
                        {formatNumberForLanguage((publicStats.registered || 0).toLocaleString(), currentLanguage)
                        }
                      </h3>
                      <p className="text-lg font-semibold text-gray-700"><TranslatedText>Total Registered</TranslatedText></p>
                      <p className="mt-1 text-sm text-gray-600"><TranslatedText>Complaints Received</TranslatedText></p>
                    </>
                  )}
                </div>

                <div className="relative rounded-2xl border-2 border-green-200 bg-gradient-to-br from-green-50 to-emerald-50 p-8 text-center shadow-lg transition-all duration-300 hover:shadow-xl">
                  <div className="absolute right-4 top-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100">
                    <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                  </div>
                  {publicStats.loading ? (
                    <div className="animate-pulse">
                      <div className="mx-auto mb-3 h-12 w-24 rounded bg-gray-200"></div>
                      <div className="mx-auto h-4 w-32 rounded bg-gray-200"></div>
                    </div>
                  ) : (
                    <>
                      <h3 className="mb-3 text-4xl font-bold text-green-600">
                        {formatNumberForLanguage((publicStats.resolved || 0).toLocaleString(), currentLanguage)}
                      </h3>
                      <p className="text-lg font-semibold text-gray-700"><TranslatedText>Successfully Resolved</TranslatedText></p>
                      <p className="mt-1 text-sm text-gray-600"><TranslatedText>Complaints Closed</TranslatedText></p>
                    </>
                  )}
                </div>

                <div className="relative rounded-2xl border-2 border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50 p-8 text-center shadow-lg transition-all duration-300 hover:shadow-xl">
                  <div className="absolute right-4 top-4 flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
                    <svg className="h-6 w-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  {publicStats.loading ? (
                    <div className="animate-pulse">
                      <div className="mx-auto mb-3 h-12 w-16 rounded bg-gray-200"></div>
                      <div className="mx-auto h-4 w-24 rounded bg-gray-200"></div>
                    </div>
                  ) : (
                    <>
                      <h3 className="mb-3 text-4xl font-bold text-blue-600">
                        {formatNumberForLanguage(`${publicStats.registered > 0
                          ? Math.round((publicStats.resolved / publicStats.registered) * 100)
                          : 0}%`, currentLanguage)}
                      </h3>
                      <p className="text-lg font-semibold text-gray-700"><TranslatedText>Resolution Rate</TranslatedText></p>
                      <p className="mt-1 text-sm text-gray-600"><TranslatedText>Success Percentage</TranslatedText></p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>




        </div>
      </div>
    );
  };

  const renderAdvancedReportsTab = () => (
    <div>
      <h2 className="mb-8 text-2xl font-bold text-gray-900">
        <TranslatedText> Advanced Reports & Analytics</TranslatedText>
      </h2>

      {/* Report Filters */}
      <div className="mb-8 rounded-2xl border border-gray-100 bg-white p-8 shadow-lg">
        <h3 className="mb-6 text-xl font-bold text-gray-900">
          <TranslatedText> Custom Report Builder</TranslatedText>
        </h3>
        <div className="mb-6 grid grid-cols-1 gap-6 md:grid-cols-3">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              <TranslatedText> From Date</TranslatedText>
            </label>
            <input
              type="date"
              name="Date From"
              value={filters.dateFrom}
              onChange={(e) =>
                setFilters({ ...filters, dateFrom: e.target.value })
              }
              max={new Date().toISOString().split('T')[0]}
              placeholder="From Date"
              className="w-full rounded-xl border-gray-200 bg-white px-4 py-3 text-sm shadow-sm transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              <TranslatedText> To Date</TranslatedText>
            </label>
            <input
              type="date"
              name="dateTo"
              value={filters.dateTo}
              // onChange={handleFilterChange}
              onChange={(e) =>
                setFilters({ ...filters, dateTo: e.target.value })
              }
              max={new Date().toISOString().split('T')[0]}
              placeholder="To Date"
              className="w-full rounded-xl border-gray-200 bg-white px-4 py-3 text-sm shadow-sm transition-all focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20"
            />
          </div>
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              {t('dashboard.table.department')}
            </label>
            <select
              name="department"
              value={filters.departmentId || ''}
              onChange={(e) => {
                const selectedDep = departments.find(
                  (dep) => dep.id.toString() === e.target.value
                );
                setFilters({
                  ...filters,
                  department: selectedDep?.name || '',
                  departmentId: selectedDep?.id || '',
                });
              }}
              required
              className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-blue-500"
            >
              <option value=""><TranslatedText>Department</TranslatedText></option>
              {departments.map((dep) => (
                <option key={dep.id} value={dep.id}>
                  <TranslatedText>{dep.name}</TranslatedText>
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mb-8 grid grid-cols-1 gap-6 md:grid-cols-3">
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              {t('complaint.form.taluka')}
            </label>
            <select
              name="taluka"
              value={filters.taluka}
              onChange={(e) =>
                setFilters({ ...filters, taluka: e.target.value })
              }
              required
              className="w-full rounded-lg border border-gray-300 px-4 py-2 focus:border-transparent focus:ring-2 focus:ring-blue-500"
            >
              <option value=""><TranslatedText>Select Taluka</TranslatedText></option>
              {talukas.map((taluka) => (
                <option key={taluka.id} value={taluka.name}>
                  <TranslatedText>{taluka.name}</TranslatedText>
                </option>
              ))}
            </select>
          </div>
          {/* <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">Category</label>
            <select
              value={reportFilters.category}
              onChange={(e) => setReportFilters({...reportFilters, category: e.target.value})}
              className="w-full appearance-none rounded-xl border border-gray-200 bg-white py-3 pl-4 pr-10 text-sm shadow-sm transition-all focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20"
            >
              <option value="">All Categories</option>
              <option value="water">Water Supply</option>
              <option value="electricity">Electricity</option>
              <option value="roads">Roads</option>
              <option value="cleanliness">Cleanliness</option>
            </select>
          </div> */}
          <div>
            <label className="mb-2 block text-sm font-medium text-gray-700">
              {t('dashboard.table.status')}
            </label>
            <select
              name="status"
              value={filters.status}
              onChange={handleFilterChange}
              className="w-full appearance-none rounded-xl border border-gray-200 bg-white py-3 pl-4 pr-10 text-sm shadow-sm transition-all focus:border-yellow-500 focus:ring-2 focus:ring-yellow-500/20"
            >
              <option value="ALL STATUS">{t('status.allStatus')}</option>
              <option value="NEW">{t('status.new')}</option>
              <option value="IN_PROGRESS">{t('status.inProgress')}</option>
              <option value="RESOLVED">{t('status.resolved')}</option>
              <option value="REJECTED">{t('status.rejected')}</option>
              <option value="REOPEN">{t('status.reopened')}</option>
              <option value="PENDING">{t('status.pending')}</option>
            </select>
          </div>
        </div>
        <div className="mt-6 flex items-center gap-4">
          <div ref={dropdownRef} className="relative inline-block text-left">
            <button
              onClick={() => setOpen(!open)}
              className="flex items-center gap-2 rounded-lg bg-green-600 px-6 py-3 font-medium text-white transition-colors hover:bg-green-700"
            >
              <TranslatedText>Reports</TranslatedText>
              <ChevronDown className="h-4 w-4" />
            </button>

            {open && (
              <div className="absolute left-0 z-10 mt-2 w-56 overflow-hidden rounded-lg border border-green-200 bg-white shadow-xl">
                {/* Export to Excel */}
                <button
                  onClick={() => {
                    handleGenerateExcel();
                    setOpen(false);
                  }}
                  className="flex w-full items-center gap-2 px-4 py-3 text-left font-medium text-gray-800 transition-colors hover:bg-green-50 hover:text-green-700"
                >
                  📊 <span>{t('reports.exportExcel')}</span>
                </button>

                {/* Daily CRM Report */}
                <button
                  onClick={() => {
                    handleDownloadComplaintCountReport();
                    setOpen(false);
                  }}
                  className="flex w-full items-center gap-2 border-t border-gray-100 px-4 py-3 text-left font-medium text-gray-800 transition-colors hover:bg-green-50 hover:text-green-700"
                >
                  📅 <span>{t('reports.crmReport')}</span>
                </button>

                {/* Aging Report */}
                <button
                  onClick={() => {
                    handleDownloadAgingReport();
                    setOpen(false);
                  }}
                  className="flex w-full items-center gap-2 border-t border-gray-100 px-4 py-3 text-left font-medium text-gray-800 transition-colors hover:bg-green-50 hover:text-green-700"
                >
                  ⏳ <span>{t('reports.agingReport')}</span>
                </button>
              </div>
            )}
          </div>

          {/* Other buttons */}
          <button
            onClick={handleGenerateReport}
            className="rounded-lg bg-red-600 px-6 py-3 font-medium text-white transition-colors hover:bg-red-700"
          >
            {t('reports.exportPdf')}
          </button>

          <button
            onClick={handleScheduleClick}
            disabled
            className="rounded-lg bg-purple-600 px-6 py-3 font-medium text-white transition-colors hover:bg-purple-700"
          >
            {t('reports.schedule')}
          </button>
        </div>
      </div>

      <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-lg">
        {/* Color Legend */}
        <div className="border-b border-gray-200 bg-gray-50 px-6 py-3">
          <div className="flex items-center gap-4 text-xs text-gray-600">
            <div
              onClick={() =>
                setFilters((prev) => ({
                  ...prev,
                  raisedByCollector: !prev.raisedByCollector,
                  raisedByCitizen: !prev.raisedByCollector ? false : prev.raisedByCitizen,
                }))
              }
              className={`flex items-center gap-1.5 cursor-pointer px-2 py-1 rounded transition-all border ${filters.raisedByCollector
                ? 'bg-purple-100 border-purple-300 shadow-sm'
                : 'hover:bg-gray-100 border-transparent'
                }`}
            >
              <span className="h-3 w-3 rounded bg-purple-600"></span>
              <span className={`font-semibold ${filters.raisedByCollector ? 'text-purple-800' : 'text-purple-700'}`}>
                ★ {t('legend.collectorPriority')}
              </span>
              {filters.raisedByCollector && <span className="ml-1 text-purple-600">✓</span>}
            </div>

            <span className="text-gray-300">|</span>

            <div
              onClick={() =>
                setFilters((prev) => ({
                  ...prev,
                  raisedByCitizen: !prev.raisedByCitizen,
                  raisedByCollector: !prev.raisedByCitizen ? false : prev.raisedByCollector,
                }))
              }
              className={`flex items-center gap-1.5 cursor-pointer px-2 py-1 rounded transition-all border ${filters.raisedByCitizen
                ? 'bg-blue-100 border-blue-300 shadow-sm'
                : 'hover:bg-gray-100 border-transparent'
                }`}
            >
              <span className="h-3 w-3 rounded border border-gray-300 bg-white"></span>
              <span className={filters.raisedByCitizen ? 'text-blue-800 font-medium' : ''}>
                {t('legend.citizenRaised')}
              </span>
              {filters.raisedByCitizen && <span className="ml-1 text-blue-600">✓</span>}
            </div>
          </div>
        </div>

        {/* Complaints Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.complaintId')}
                </th>
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.submittedDate')}
                </th>
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.resolvedDate')}
                </th>
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.citizenDetails')}
                </th>
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.taluka')}
                </th>
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.department')}
                </th>
                {/* <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  Officer Assign
                </th> */}
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.status')}
                </th>
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                </th>
                <th className="whitespace-nowrap px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  <TranslatedText>Raised By</TranslatedText>
                </th>
              </tr>
            </thead>

            <tbody className="bg-white">
              {filteredComplaints.map((complaint) => (
                <tr
                  key={complaint.complaintId}
                  className={` border-gray-50 transition-colors ${complaint.raisedBy === 'COLLECTOR'
                    ? 'bg-purple-100 hover:bg-purple-150 border-l-4 border-purple-600 shadow-sm'
                    : 'hover:bg-gray-50/50'
                    }`}
                >
                  <td
                    className="cursor-pointer px-8 py-6 text-sm font-semibold"
                    onClick={() => handleViewDetails(complaint)}
                  >
                    <div className="flex items-center gap-2">
                      {complaint.raisedBy === 'COLLECTOR' && (
                        <span className="font-bold text-purple-700">★</span>
                      )}
                      <span
                        className={
                          complaint.raisedBy === 'COLLECTOR'
                            ? 'text-purple-700 font-bold'
                            : 'text-blue-700'
                        }
                      >
                        {complaint.complaintId || 'NA'}
                      </span>
                    </div>
                  </td>

                  <td className="px-8 py-6 text-sm text-gray-600">
                    {formatDateTime(complaint.submittedDate)}
                  </td>
                  <td className="px-8 py-6 text-sm text-gray-600">
                    {complaint.resolvedDate ? formatDateTime(complaint.resolvedDate) : 'NA'}
                  </td>
                  <td className="px-8 py-6">
                    <div className="text-sm font-semibold text-gray-900">
                      <TranslatedText>{complaint.name || 'NA'}</TranslatedText>
                    </div>
                    <div className="mt-1 text-sm text-gray-500">
                      {formatNumberForLanguage(complaint.mobile || 'NA', currentLanguage)}
                    </div>
                    <div className="text-sm text-gray-500">
                      <TranslatedText>{complaint.village || 'NA'}</TranslatedText>
                    </div>
                  </td>
                  <td className="px-8 py-6 text-sm text-gray-600">
                    <TranslatedText>{complaint.taluka || 'NA'}</TranslatedText>
                  </td>
                  <td className="px-8 py-6 text-sm text-gray-600">
                    <TranslatedText>{complaint.departmentName || 'NA'}</TranslatedText>
                  </td>
                  {/* <td className="px-8 py-6 text-sm text-gray-600">{complaint.officerAssigned || 'NA'}</td> */}
                  <td className="px-8 py-6">
                    <span
                      className={`inline-flex px-3 py-2 text-xs font-semibold whitespace-nowrap rounded-full ${getStatusColor(complaint.status)}`}
                    >
                      <TranslatedText>{formatStatus(complaint.status) || 'NA'}</TranslatedText>
                    </span>
                  </td>
                  <td className="px-8 py-6">
                    <span
                      className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${getPendingDaysStatusColor(complaint.pendingDays !== undefined ? complaint.pendingDays : complaint.pendingDay || complaint.PendingDays)}`}
                    >
                      {formatNumberForLanguage(complaint.pendingDays !== undefined
                        ? complaint.pendingDays
                        : complaint.pendingDay || complaint.PendingDays || 'NA', currentLanguage)}
                    </span>
                  </td>
                  <td className="px-8 py-6">
                    <span className={`inline-flex px-3 py-2 text-xs font-bold rounded-full ${complaint.raisedBy === "COLLECTOR"
                      ? "bg-purple-600 text-white"
                      : "bg-gray-100 text-green-800"
                      }`}>
                      <TranslatedText>
                        {complaint.raisedBy
                          ? `raisedBy.${complaint.raisedBy.toLowerCase() === 'admin' ? 'admin' : complaint.raisedBy.toLowerCase()}`
                          : ''}
                      </TranslatedText>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="border-t border-gray-200 bg-gray-50 px-6 py-4">
            <div className="flex items-center justify-between">
              <div className="text-sm text-gray-700">
                {currentLanguage === 'mr' ? `पृष्ठ ${formatNumberForLanguage(currentPage, currentLanguage)} च ${formatNumberForLanguage(totalPages, currentLanguage)} (${formatNumberForLanguage(totalComplaints, currentLanguage)} तक्रार)` : `Page ${formatNumberForLanguage(currentPage, currentLanguage)} of ${formatNumberForLanguage(totalPages, currentLanguage)} (${formatNumberForLanguage(totalComplaints, currentLanguage)} complaints)`}
              </div>
              <div className="flex items-center gap-2">
                {/* First Page */}
                <button
                  onClick={goToFirstPage}
                  disabled={currentPage === 1}
                  className="rounded border border-gray-300 px-3 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {t('pagination.first')}
                </button>

                {/* Previous Page */}
                <button
                  onClick={goToPreviousPage}
                  disabled={currentPage === 1}
                  className="flex items-center rounded border border-gray-300 px-2 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  <ChevronLeft className="h-4 w-4" />
                </button>

                {/* Page Numbers */}
                <div className="flex items-center gap-1">
                  {(() => {
                    const pages = [];
                    const showPages = 5;
                    let startPage = Math.max(1, currentPage - 2);
                    let endPage = Math.min(
                      totalPages,
                      startPage + showPages - 1
                    );

                    // Adjust start if we're near the end
                    if (endPage - startPage < showPages - 1) {
                      startPage = Math.max(1, endPage - showPages + 1);
                    }

                    // Add ellipsis at start
                    if (startPage > 1) {
                      pages.push(
                        <button
                          key={1}
                          onClick={() => goToPage(1)}
                          className={`px-3 py-1 border rounded text-sm ${currentPage === 1 ? 'bg-yellow-600 text-white border-yellow-600' : 'border-gray-300 hover:bg-gray-100'}`}
                        >
                          1
                        </button>
                      );
                      if (startPage > 2) {
                        pages.push(
                          <span
                            key="start-ellipsis"
                            className="px-2 text-gray-500"
                          >
                            ...
                          </span>
                        );
                      }
                    }

                    // Add page numbers
                    for (let i = startPage; i <= endPage; i++) {
                      pages.push(
                        <button
                          key={i}
                          onClick={() => goToPage(i)}
                          className={`px-3 py-1 border rounded text-sm ${currentPage === i ? 'bg-yellow-600 text-white border-yellow-600' : 'border-gray-300 hover:bg-gray-100'}`}
                        >
                          {i}
                        </button>
                      );
                    }

                    // Add ellipsis at end
                    if (endPage < totalPages) {
                      if (endPage < totalPages - 1) {
                        pages.push(
                          <span
                            key="end-ellipsis"
                            className="px-2 text-gray-500"
                          >
                            ...
                          </span>
                        );
                      }
                      pages.push(
                        <button
                          key={totalPages}
                          onClick={() => goToPage(totalPages)}
                          className={`px-3 py-1 border rounded text-sm ${currentPage === totalPages ? 'bg-yellow-600 text-white border-yellow-600' : 'border-gray-300 hover:bg-gray-100'}`}
                        >
                          {totalPages}
                        </button>
                      );
                    }

                    return pages;
                  })()}
                </div>

                {/* Next Page */}
                <button
                  onClick={goToNextPage}
                  disabled={currentPage === totalPages}
                  className="flex items-center rounded border border-gray-300 px-2 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  <ChevronRight className="h-4 w-4" />
                </button>

                {/* Last Page */}
                <button
                  onClick={goToLastPage}
                  disabled={currentPage === totalPages}
                  className="rounded border border-gray-300 px-3 py-1 text-sm hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-50"
                >
                  {t('pagination.last')}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Complaint Detail Modal */}
      {showDetailModal && selectedComplaint && (
        <div className="fixed inset-0 z-[9999] h-full w-full overflow-y-auto bg-gray-600 bg-opacity-50">
          <div className="relative top-20 mx-auto w-11/12 max-w-4xl overflow-hidden rounded-xl border border-gray-200/50 bg-white shadow-2xl backdrop-blur-sm md:w-3/4 lg:w-1/2">
            <div>
              {/* Modal Header */}
              <div
                className="border-b border-gray-200 px-8 py-6"
                style={{
                  background: 'linear-gradient(135deg, #B8860B 0%, #DAA520 100%)',
                }}
              >
                <h2 className="text-2xl font-bold text-white">
                  <TranslatedText>Complaint Details -</TranslatedText> {selectedComplaint.complaintId}
                </h2>
                <p className="mt-1 text-sm text-yellow-100">
                  <TranslatedText>Complete information about this citizen complaint</TranslatedText>
                </p>
                <button
                  onClick={handleCloseModal}
                  className="absolute right-4 top-4 rounded-full p-2 text-2xl text-yellow-100 transition-colors hover:bg-yellow-900/20 hover:text-white"
                >
                  ×
                </button>
              </div>

              <div className="p-8">
                {/* Status & Priority */}
                <div className="mb-6 flex items-center gap-4">
                  <span
                    className={`inline-flex px-4 py-2 text-sm font-semibold whitespace-nowrap rounded-full ${getStatusColor(selectedComplaint.status)}`}
                  >
                    <TranslatedText>{formatStatus(selectedComplaint.status)}</TranslatedText>
                  </span>

                  <select
                    id="priority"
                    className={`text-xs font-semibold rounded-full px-4 py-1.5 border-2 appearance-none focus:outline-none cursor-pointer w-[100px]
                      ${selectedComplaint.priority === "HIGH"
                        ? "text-red-600 border-red-400 focus:ring-2 focus:ring-red-300 bg-red-50"
                        : selectedComplaint.priority === "LOW"
                          ? "text-green-600 border-green-400 focus:ring-2 focus:ring-green-300 bg-green-50"
                          : "text-yellow-600 border-yellow-400 focus:ring-2 focus:ring-yellow-300 bg-yellow-50"
                      }`}
                    value={selectedComplaint.priority || "MEDIUM"}
                    onChange={(e) =>
                      handlePriorityUpdate(selectedComplaint.id, e.target.value)
                    }
                  >
                    <option value="LOW" className="font-semibold text-green-600">
                      {t('priority.low')}
                    </option>
                    <option value="MEDIUM" className="font-semibold text-yellow-600">
                      {t('priority.medium')}
                    </option>
                    <option value="HIGH" className="font-semibold text-red-600">
                      {t('priority.high')}
                    </option>
                  </select>
                </div>

                {/* Info Grid */}
                <div className="mb-6 grid gap-6 md:grid-cols-2">
                  <div className="rounded-xl border border-gray-200 bg-gradient-to-br from-slate-50 to-gray-100 p-6">
                    <h3 className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900" style={{ color: '#B8860B' }}>
                      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: '#B8860B' }}></span>
                      <TranslatedText>Citizen Information</TranslatedText>
                    </h3>
                    <div className="space-y-3 text-sm">
                      <p><span className="font-medium text-gray-700">{t('track.details.name')}:</span> <span className="text-gray-900"><TranslatedText>{selectedComplaint.name}</TranslatedText></span></p>
                      <p><span className="font-medium text-gray-700">{t('track.details.mobile')}:</span> <span className="text-gray-900">{formatNumberForLanguage(selectedComplaint.mobile, currentLanguage)}</span></p>
                      <div>
                        <span className="font-medium text-gray-700">{t('track.details.address')}:</span>
                        <p className="mt-1 max-h-20 overflow-y-auto break-all text-sm text-gray-900"><TranslatedText>{selectedComplaint.address}</TranslatedText></p>
                      </div>
                      <p><span className="font-medium text-gray-700">{t('complaint.form.village')}:</span> <span className="text-gray-900"><TranslatedText>{selectedComplaint.village}</TranslatedText></span></p>
                      <p><span className="font-medium text-gray-700">{t('complaint.form.taluka')}:</span> <span className="text-gray-900"><TranslatedText>{selectedComplaint.taluka}</TranslatedText></span></p>
                    </div>
                  </div>

                  <div className="rounded-xl border border-gray-200 bg-gradient-to-br from-slate-50 to-gray-100 p-6">
                    <h3 className="mb-4 flex items-center gap-2 text-lg font-semibold text-gray-900" style={{ color: '#B8860B' }}>
                      <span className="h-2 w-2 rounded-full" style={{ backgroundColor: '#B8860B' }}></span>
                      {t('modal.complaintInfo')}
                    </h3>
                    <div className="space-y-3 text-sm">
                      <p><span className="font-medium text-gray-700">{t('dashboard.table.submittedDate')}:</span> <span className="text-gray-900">{formatNumberForLanguage(selectedComplaint.submittedDate, currentLanguage)}</span></p>
                      <p><span className="font-medium text-gray-700">{t('dashboard.filter.assignedTo')}:</span> <span className="text-gray-900"><TranslatedText>{selectedComplaint.assignedTo}</TranslatedText></span></p>
                      <p>
                        <span className="font-medium text-gray-700">{t('dashboard.table.priority')}:</span>{' '}
                        <span className={`px-2 py-1 rounded-full text-xs font-semibold ${selectedComplaint.priority === "HIGH" ? "bg-red-100 text-red-700" : selectedComplaint.priority === "LOW" ? "bg-green-100 text-green-700" : "bg-yellow-100 text-yellow-700"}`}>
                          <TranslatedText>{selectedComplaint.priority ? `priority.${selectedComplaint.priority}` : 'NA'}</TranslatedText>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>

                {/* Description */}
                <div className="mb-6">
                  <h3 className="mb-3 text-lg font-semibold text-gray-900">{t('admin.modal.complaintDescription')}</h3>
                  <div className="rounded-xl border border-blue-200 bg-gradient-to-br from-blue-50 to-indigo-50 p-4">
                    <div className="scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 max-h-40 overflow-y-auto rounded-lg pr-2">
                      <TranslatedText tag="p" className="word-wrap-300 leading-relaxed text-gray-800" style={{ wordBreak: 'keep-all', overflowWrap: 'break-word', hyphens: 'none' }}>
                        {selectedComplaint.description || t('admin.modal.noDescription')}
                      </TranslatedText>
                    </div>
                  </div>
                </div>

                {/* Officer Notes */}
                {selectedComplaint.officerNotes && (
                  <div className="mb-6">
                    <h3 className="mb-3 text-lg font-semibold text-gray-900">{t('admin.modal.officerNotes')}</h3>
                    <div className="rounded-r-xl border-l-4 bg-gradient-to-br from-yellow-50 to-amber-50 p-4" style={{ borderLeftColor: '#B8860B' }}>
                      <div className="scrollbar-thin scrollbar-thumb-yellow-400 scrollbar-track-yellow-100 max-h-40 overflow-y-auto rounded-lg pr-2">
                        <TranslatedText tag="p" className="whitespace-pre-line break-words leading-relaxed text-gray-800">
                          {selectedComplaint.officerNotes}
                        </TranslatedText>
                      </div>
                    </div>
                  </div>
                )}

                {/* Timeline */}
                <div className="mb-6">
                  <h3 className="mb-4 text-lg font-semibold text-gray-900">{t('admin.modal.actionTimeline')}</h3>
                  <div className="rounded-xl border border-green-200 bg-gradient-to-br from-green-50 to-emerald-50 p-6">
                    <div className="max-h-96 space-y-4 overflow-y-auto break-all">
                      {Array.isArray(selectedTimeLine) && selectedTimeLine.length > 0 ? (
                        selectedTimeLine.map((event, index) => (
                          <div key={index} className="flex items-start">
                            <div className="flex items-center">
                              <div className="h-4 w-4 rounded-full" style={{ backgroundColor: '#B8860B' }}></div>
                              {index < selectedTimeLine.length - 1 && <div className="ml-2 mt-2 h-12 w-px" style={{ backgroundColor: '#B8860B' }}></div>}
                            </div>
                            <div className="ml-4 flex-1">
                              <div className="flex items-start justify-between">
                                <div className="mr-4 flex-1 rounded-lg border border-green-200 bg-white p-3">
                                  <h4 className="mb-1 font-semibold text-gray-900">
                                    <TranslatedText>{event.action || t('dashboard.timeline.actionTaken')}</TranslatedText>
                                  </h4>
                                  {event.note && (
                                    <TranslatedText tag="p" className="mb-1 break-all text-xs text-gray-700">
                                      {event.note}
                                    </TranslatedText>
                                  )}
                                </div>
                                <div className="whitespace-nowrap rounded border border-green-200 bg-white px-2 py-1 text-xs text-gray-500">
                                  {formatNumberForLanguage(event.date, currentLanguage)}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <p className="text-sm text-gray-600">{t('admin.modal.noTimeline')}</p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Footer buttons */}
                <div className="flex justify-end border-t border-gray-200 pt-6">
                  <button
                    onClick={handleCloseModal}
                    className="rounded-lg bg-gray-600 px-6 py-2 font-medium text-white transition-colors hover:bg-gray-700"
                  >
                    {t('admin.modal.close')}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Assign Complaint Modal */}
      {showAssignModal && assignComplaint && (
        <AssignComplaintPage
          complaint={assignComplaint}
          onClose={handleAssignClose}
          onAssign={handleAssign}
        />
      )}
    </div>
  );
  const renderAuditTab = () => (
    <div>
      <h2 className="mb-6 text-2xl font-bold text-gray-900">
        Audit Trail & Quality Assurance
      </h2>

      {/* Audit Log Filters */}
      <div className="mb-8 rounded-lg bg-white p-6 shadow">
        <h3 className="mb-4 text-lg font-semibold">Audit Log Filters</h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
          <select className="rounded border border-gray-300 px-3 py-2">
            <option value="">All Actions</option>
            <option value="login">Login/Logout</option>
            <option value="status">Status Changes</option>
            <option value="assignment">Assignments</option>
            <option value="creation">Complaint Creation</option>
          </select>
          <select className="rounded border border-gray-300 px-3 py-2">
            <option value="">All Users</option>
            <option value="officers">Officers Only</option>
            <option value="admin">Admin Only</option>
            <option value="system">System Actions</option>
          </select>
          <input
            type="date"
            className="rounded border border-gray-300 px-3 py-2"
          />
          <button className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
            Apply Filters
          </button>
        </div>
      </div>

      {/* Audit Logs Table */}
      <div className="mb-8 rounded-lg bg-white shadow">
        <div className="border-b border-gray-200 px-6 py-4">
          <h3 className="text-lg font-semibold text-gray-900">
            System Audit Logs
          </h3>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase text-gray-500">
                  Timestamp
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase text-gray-500">
                  Action
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase text-gray-500">
                  User
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase text-gray-500">
                  Target
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase text-gray-500">
                  Details
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium uppercase text-gray-500">
                  IP Address
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {auditLogs.map((log) => (
                <tr key={log.id}>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                    {log.timestamp}
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                    <span
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${log.action === 'STATUS_UPDATE'
                        ? 'bg-blue-100 text-blue-800'
                        : log.action === 'COMPLAINT_ASSIGNED'
                          ? 'bg-green-100 text-green-800'
                          : log.action === 'COMPLAINT_CREATED'
                            ? 'bg-purple-100 text-purple-800'
                            : log.action === 'USER_LOGIN'
                              ? 'bg-gray-100 text-gray-800'
                              : 'bg-yellow-100 text-yellow-800'
                        }`}
                    >
                      {log.action.replace('_', ' ')}
                    </span>
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                    {log.user}
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-900">
                    {log.target}
                  </td>
                  <td className="max-w-xs truncate px-6 py-4 text-sm text-gray-900">
                    {log.details}
                  </td>
                  <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                    {log.ipAddress}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      {/* 
      Data Compliance */}
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">
        <div className="rounded-lg bg-white p-6 shadow">
          <h3 className="mb-4 text-lg font-semibold">Data Compliance Status</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span>GDPR Compliance</span>
              <span className="font-semibold text-green-600">✓ Active</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Data Retention Policy</span>
              <span className="font-semibold text-green-600">✓ 7 Years</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Backup Schedule</span>
              <span className="font-semibold text-green-600">✓ Daily</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Audit Log Retention</span>
              <span className="font-semibold text-green-600">✓ 3 Years</span>
            </div>
          </div>
        </div>

        <div className="rounded-lg bg-white p-6 shadow">
          <h3 className="mb-4 text-lg font-semibold">Quality Metrics</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <span>Random Audits Completed</span>
              <span className="font-semibold">15/20</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Quality Score</span>
              <span className="font-semibold text-green-600">88%</span>
            </div>
            <div className="flex items-center justify-between">
              <span>Compliance Issues</span>
              <span className="font-semibold text-red-600">2 Open</span>
            </div>
            <button className="w-full rounded bg-blue-600 py-2 text-white hover:bg-blue-700">
              Generate Compliance Report
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  const renderCollaborationTab = () => {
    const handleSendMessage = (e) => {
      e.preventDefault();
      if (newMessage.trim()) {
        const message = {
          id: chatMessages.length + 1,
          sender: 'Current User',
          message: newMessage,
          timestamp: new Date()
            .toISOString()
            .replace('T', ' ')
            .substring(0, 16),
          avatar: 'CU',
        };
        setChatMessages([...chatMessages, message]);
        setNewMessage('');
      }
    };

    return (
      <div>
        {/* <h2 className="mb-6 text-2xl font-bold text-gray-900">
          Collaboration Hub
        </h2> */}

        {/* <div className="mb-8 grid grid-cols-1 gap-8 lg:grid-cols-2"> */}
        {/* Team Chat */}
        {/* <div className="rounded-lg bg-white p-6 shadow">
            <h3 className="mb-4 text-lg font-semibold">Team Communication</h3> */}

        {/* Chat Messages */}
        {/* <div className="mb-4 h-80 overflow-y-auto rounded border border-gray-200 p-4">
              <div className="space-y-4">
                {chatMessages.map((message) => (
                  <div key={message.id} className="flex items-start space-x-3">
                    <div className="flex-shrink-0">
                      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-blue-500 text-xs font-semibold text-white">
                        {message.avatar}
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center space-x-2">
                        <span className="text-sm font-semibold">
                          {message.sender}
                        </span>
                        <span className="text-xs text-gray-500">
                          {message.timestamp}
                        </span>
                      </div>
                      <p className="mt-1 text-sm text-gray-700">
                        {message.message}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Message Input */}
        {/* <form onSubmit={handleSendMessage} className="flex space-x-2">
              <input
                type="text"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type a message..."
                className="flex-1 rounded border border-gray-300 px-3 py-2"
              />
              <button
                type="submit"
                className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
              >
                Send
              </button>
            </form>
          </div> */}
        {/* Knowledge Base */}
        {/* <div className="rounded-lg bg-white p-6 shadow">
            <div className="mb-4 flex items-center justify-between">
              <h3 className="text-lg font-semibold">Knowledge Base</h3>
              <button className="rounded bg-green-600 px-4 py-2 text-sm text-white hover:bg-green-700">
                Add Article
              </button>
            </div>

            <div className="space-y-4">
              {mockKnowledgeBase.map((article) => (
                <div
                  key={article.id}
                  className="rounded border border-gray-200 p-4"
                >
                  <div className="mb-2 flex items-start justify-between">
                    <h4 className="cursor-pointer font-semibold text-blue-600 hover:text-blue-800">
                      {article.title}
                    </h4>
                    <span className="rounded bg-gray-100 px-2 py-1 text-xs text-gray-700">
                      {article.category}
                    </span>
                  </div>
                  <p className="mb-2 text-sm text-gray-600">
                    {article.content}
                  </p>
                  <div className="flex justify-between text-xs text-gray-500">
                    <span>Updated: {article.lastUpdated}</span>
                    <span>By: {article.updatedBy}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 rounded bg-blue-50 p-4">
              <h4 className="mb-2 font-semibold text-blue-800">
                Quick Actions
              </h4>
              <div className="grid grid-cols-2 gap-2">
                <button className="rounded bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700">
                  Search KB
                </button>
                <button className="rounded bg-purple-600 px-3 py-2 text-sm text-white hover:bg-purple-700">
                  FAQ Section
                </button>
              </div>
            </div>
          </div> */}
        {/* </div> */}

        {/* File Sharing
        <div className="mb-8 rounded-lg bg-white p-6 shadow">
          <h3 className="mb-4 text-lg font-semibold">Document Sharing</h3>

          <div className="rounded-lg border-2 border-dashed border-gray-300 p-8 text-center">
            <div className="mb-4 text-4xl">📎</div>
            <p className="mb-4 text-gray-600">
              Drag and drop files here or click to browse
            </p>
            <button className="rounded bg-blue-600 px-6 py-2 text-white hover:bg-blue-700">
              Choose Files
            </button>
          </div>

          <div className="mt-6">
            <h4 className="mb-3 font-semibold">Recently Shared Files</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between rounded border border-gray-200 p-3">
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">📄</span>
                  <div>
                    <p className="font-medium">SLA_Guidelines_2024.pdf</p>
                    <p className="text-sm text-gray-500">
                      Shared by Admin User • 2 hours ago
                    </p>
                  </div>
                </div>
                <button className="text-blue-600 hover:text-blue-800">
                  Download
                </button>
              </div>
              <div className="flex items-center justify-between rounded border border-gray-200 p-3">
                <div className="flex items-center space-x-3">
                  <span className="text-2xl">🖼️</span>
                  <div>
                    <p className="font-medium">complaint_photos_jan2024.zip</p>
                    <p className="text-sm text-gray-500">
                      Shared by Rajesh Kumar • 1 day ago
                    </p>
                  </div>
                </div>
                <button className="text-blue-600 hover:text-blue-800">
                  Download
                </button>
              </div>
            </div>
          </div>
        </div> */}

        {/* Meeting Scheduler */}
        {/* <div className="rounded-lg bg-white p-6 shadow">
          <h3 className="mb-4 text-lg font-semibold">Meeting Scheduler</h3>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
            <div>
              <h4 className="mb-3 font-semibold">Schedule New Meeting</h4>
              <form className="space-y-4">
                <input
                  type="text"
                  placeholder="Meeting Title"
                  className="w-full rounded border border-gray-300 px-3 py-2"
                />
                <input
                  type="datetime-local"
                  className="w-full rounded border border-gray-300 px-3 py-2"
                />
                <select className="w-full rounded border border-gray-300 px-3 py-2">
                  <option value="">Select Attendees</option>
                  <option value="all">All Officers</option>
                  <option value="dept">Department Heads</option>
                  <option value="custom">Custom Selection</option>
                </select>
                <button className="w-full rounded bg-green-600 py-2 text-white hover:bg-green-700">
                  Schedule Meeting
                </button>
              </form>
            </div>

            <div>
              <h4 className="mb-3 font-semibold">Upcoming Meetings</h4>
              <div className="space-y-3">
                <div className="rounded border border-gray-200 p-3">
                  <p className="font-medium">Monthly Review Meeting</p>
                  <p className="text-sm text-gray-500">Tomorrow, 2:00 PM</p>
                  <p className="text-sm text-gray-600">
                    With: All Department Heads
                  </p>
                </div>
                <div className="rounded border border-gray-200 p-3">
                  <p className="font-medium">Water Department Sync</p>
                  <p className="text-sm text-gray-500">Jan 25, 10:00 AM</p>
                  <p className="text-sm text-gray-600">
                    With: Water Dept Officers
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    );
  };

  const renderOfficersTab = () => (
    <div className="space-y-6">
      {/* Header with Action Button */}
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <div className="flex items-center space-x-3">
            <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-blue-100">
              <Users className="h-6 w-6 text-blue-600" />
            </div>
            <div>
              <h3 className="text-xl font-semibold text-gray-900">
                <TranslatedText>System Users</TranslatedText>
              </h3>
              <p className="text-sm text-gray-600">
                <TranslatedText>Manage Users And Their Access Permissions</TranslatedText>
              </p>
            </div>
          </div>
        </div>

        {/* Add Button */}
        <button
          onClick={() => {
            setNewOfficer({
              name: '',
              email: '',
              userId: '',
              role: '',
              departmentId: '',
              password: '',
              userName: '',
            });
            setIsEditMode(false);
            setEditingOfficerId(null);
            setShowAddOfficer(true);
          }}
          className="flex items-center space-x-2 rounded-lg bg-blue-600 px-6 py-2 text-white transition-colors duration-200 hover:bg-blue-700"
        >
          <Users className="h-5 w-5" />
          <span><TranslatedText>Add New Users</TranslatedText></span>
        </button>
      </div>

      {/* Add / Edit Officer Form */}
      {showAddOfficer && (
        <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
          {/* Form Header */}
          <div className="mb-6 flex items-center justify-between">
            <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900">
              <User className="h-5 w-5" />
              <span><TranslatedText>{isEditMode ? 'Edit User' : 'Add New User'}</TranslatedText></span>
            </h4>
            <button
              onClick={() => setShowAddOfficer(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              // Validation: email ≠ username
              if (newOfficer.email === newOfficer.userName) {
                alert('Email and Username cannot be the same!');
                return;
              }

              if (isEditMode) {
                handleEditOfficer(e);
              } else {
                handleAddOfficer(e);
              }
            }}
            className="space-y-6"
          >
            {/* First row: Full Name, Email, User Name */}
            <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
              {/* Full Name */}
              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">
                  {t('complaint.form.name')} *
                </label>
                <input
                  type="text"
                  placeholder={t('admin.form.enterFullName')}
                  value={newOfficer.name}
                  onChange={(e) =>
                    setNewOfficer({ ...newOfficer, name: e.target.value })
                  }
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* Email */}
              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">
                  {t('home.contact.email')} *
                </label>
                <input
                  type="email"
                  placeholder={t('admin.form.enterEmail')}
                  value={newOfficer.email}
                  onChange={(e) =>
                    setNewOfficer({ ...newOfficer, email: e.target.value })
                  }
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>

              {/* User Name */}
              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">
                  {t('login.username')} *
                </label>
                <input
                  type="text"
                  placeholder={t('admin.form.enterUserName')}
                  value={newOfficer.userName}
                  onChange={(e) =>
                    setNewOfficer({ ...newOfficer, userName: e.target.value })
                  }
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            </div>

            {/* Second row: Role & Department */}
            <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
              {/* Role */}
              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">
                  <TranslatedText>Role</TranslatedText> *
                </label>
                <select
                  value={newOfficer.role}
                  onChange={(e) =>
                    setNewOfficer({ ...newOfficer, role: e.target.value })
                  }
                  className="w-full rounded-lg border border-gray-300 px-4 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value=""><TranslatedText>Select Officer Role</TranslatedText></option>
                  <option value="OFFICER">{t('dashboard.common.officer')}</option>
                  <option value="TALUKA_OFFICER">{t('login.demo.taluka')}</option>
                  <option value="COLLECTOR">{t('raisedBy.collector')}</option>
                  <option value="ADMIN">{t('login.demo.admin')}</option>
                </select>
              </div>

              {/* Department */}
              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">
                  {t('dashboard.table.department')} *
                </label>
                <select
                  value={newOfficer.departmentId}
                  onChange={(e) =>
                    setNewOfficer({
                      ...newOfficer,
                      departmentId: e.target.value,
                    })
                  }
                  disabled={isEditMode} //
                  className={`w-full border border-gray-300 rounded-lg px-4 py-3
                focus:ring-2 focus:ring-blue-500 focus:border-blue-500
                transition-colors duration-200
                ${isEditMode ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                  required
                >
                  <option value=""><TranslatedText>Select Department</TranslatedText></option>
                  {departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      <TranslatedText>{dept.name}</TranslatedText>
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Password - only for Add mode */}
            {!isEditMode && (
              <div>
                <label className="mb-2 block text-sm font-medium text-gray-700">
                  <TranslatedText>Password</TranslatedText> *
                </label>
                <input
                  type="password"
                  placeholder="Enter Password"
                  value={newOfficer.password}
                  onChange={(e) =>
                    setNewOfficer({ ...newOfficer, password: e.target.value })
                  }
                  className="w-1/2 rounded-lg border border-gray-300 px-3 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
            )}

            {/* Form Actions */}
            <div className="flex justify-end space-x-3 border-t border-gray-200 pt-4">
              <button
                type="button"
                onClick={() => setShowAddOfficer(false)}
                className="rounded-lg border border-gray-300 px-6 py-2 text-gray-700 transition-colors duration-200 hover:bg-gray-50"
              >
                <TranslatedText>Cancel</TranslatedText>
              </button>
              <button
                type="submit"
                className="flex items-center space-x-2 rounded-lg bg-green-600 px-6 py-2 text-white transition-colors duration-200 hover:bg-green-700"
              >
                <Users className="h-4 w-4" />
                <span><TranslatedText>{isEditMode ? 'Edit User' : 'Add User'}</TranslatedText></span>
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Officers Table */}
      <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-lg">
        <div className="border-b border-gray-100 bg-white px-8 py-6">
          <div className="flex items-center justify-between">
            <h4 className="text-2xl font-bold text-gray-900"><TranslatedText>Current Users</TranslatedText></h4>
            <div className="rounded-lg bg-gray-100 px-4 py-2 text-sm text-gray-500">
              <TranslatedText>Total</TranslatedText>  :{' '}
              <span className="font-semibold text-gray-900">
                {formatNumberForLanguage(officers.length, currentLanguage)}
              </span>{' '}
              <TranslatedText>Users</TranslatedText>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <UserSearch
            reportFilters={reportFilters}
            setReportFilters={setReportFilters}
          />
          <table className="min-w-full">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.common.officer')}
                </th>
                <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.modal.contact')}
                </th>
                <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  <TranslatedText>Role & Department</TranslatedText>
                </th>
                {/* <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">Jurisdiction</th> */}
                <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.status')}
                </th>
                <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                  {t('dashboard.table.actions')}
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              {officers
                .filter((officer) => {
                  const search = reportFilters.search?.toLowerCase() || '';
                  return (
                    officer.name?.toLowerCase().includes(search) ||
                    officer.email?.toLowerCase().includes(search) ||
                    officer.role?.toLowerCase().includes(search) ||
                    officer.department?.toLowerCase().includes(search)
                  );
                })
                .map((officer) => (
                  <tr
                    key={officer.id}
                    className="border-b border-gray-50 transition-colors hover:bg-gray-50/50"
                  >
                    <td className="px-8 py-6">
                      <div className="flex items-center">
                        <div className="mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-blue-100">
                          <User className="h-5 w-5 text-blue-600" />
                        </div>
                        <div>
                          <div className="text-sm font-semibold text-gray-900">
                            <TranslatedText>{officer.name}</TranslatedText>
                          </div>
                          <div className="text-sm text-gray-500">
                            <TranslatedText>ID: OFF{officer.id.toString().padStart(3, '0')}</TranslatedText>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-8 py-6">
                      <div className="text-sm text-gray-900">
                        <TranslatedText>{officer.email}</TranslatedText>
                      </div>
                    </td>
                    <td className="px-8 py-6">
                      <div>
                        <div className="text-sm font-semibold text-gray-900">
                          <TranslatedText>{officer.role}</TranslatedText>
                        </div>
                        <div className="text-sm text-gray-500">
                          <TranslatedText>{officer.department}</TranslatedText>
                        </div>
                      </div>
                    </td>

                    {/* <td className="px-8 py-6">
                    <div className="text-sm text-gray-900">{officer.jurisdiction}</div>
                  </td> */}
                    <td className="px-8 py-6">
                      <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-2 text-xs font-semibold text-green-800">
                        <TranslatedText>{officer.status || 'Active'}</TranslatedText>
                      </span>
                    </td>
                    <td className="px-8 py-6">
                      <div className="flex items-center space-x-3">
                        <button
                          onClick={() => {
                            setIsEditMode(true); // Edit mode ON
                            setEditingOfficerId(officer.id);
                            setNewOfficer({
                              name: officer.name,
                              email: officer.email,
                              userName: officer.userName || '',
                              role: officer.role,
                              department: officer.department,
                              // jurisdiction: officer.jurisdiction || ""
                            });
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                            setShowAddOfficer(true); // Form open
                          }}
                          className="text-blue-600 transition-colors duration-200 hover:text-blue-800"
                        >
                          {t('common.edit')}
                        </button>

                        <button
                          onClick={() => handleDeleteOfficer(officer.id)}
                          className="rounded border border-red-100 px-2 py-1 text-red-600 transition-colors duration-200 hover:text-red-800"
                        >
                          <TranslatedText> Remove</TranslatedText>
                        </button>
                        <button
                          onClick={() => handleResetPassword(officer)}
                          className="text-yellow-600 hover:text-yellow-800 px-2 py-1 rounded transition-colors duration-200 border border-yellow-100 min-w-[140px] text-center"
                        >
                          {t('login.forgotPassword')}
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );


  const renderCategoriesTab = () => {
    return (
      <div className="space-y-6">
        {/* Header with Action Button */}
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <div className="flex items-center space-x-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-orange-100">
                <Settings className="h-6 w-6 text-orange-600" />
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900">
                  Complaint Categories
                </h3>
                <p className="text-sm text-gray-600">
                  Configure complaint types and SLA targets
                </p>
              </div>
            </div>
          </div>
          <button
            onClick={() => setShowAddCategory(true)}
            className="flex items-center space-x-2 rounded-lg bg-blue-600 px-6 py-2 text-white transition-colors duration-200 hover:bg-blue-700"
          >
            <Settings className="h-5 w-5" />
            <span><TranslatedText> Add New Category</TranslatedText></span>
          </button>
        </div>

        {/* Add Category Form */}
        {showAddCategory && (
          <div className="rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
            <div className="mb-6 flex items-center justify-between">
              <h4 className="flex items-center space-x-2 text-lg font-semibold text-gray-900">
                <Settings className="h-5 w-5" />
                <span><TranslatedText> Add New Category</TranslatedText></span>
              </h4>
              <button
                onClick={() => setShowAddCategory(false)}
                className="text-gray-400 hover:text-gray-600"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <form onSubmit={handleAddCategory} className="space-y-6">
              <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
                <div>
                  <label className="mb-2 block text-sm font-medium text-gray-700">
                    <TranslatedText>  Category Name * </TranslatedText>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., Water Supply Issues"
                    value={newCategory.name}
                    onChange={(e) =>
                      setNewCategory({ ...newCategory, name: e.target.value })
                    }
                    className="w-full rounded-lg border border-gray-300 px-4 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                    required
                  />
                </div>
                <div>
                  <label className="mb-2 block text-sm font-medium text-gray-700">
                    <TranslatedText>  SLA Target (Hours) *</TranslatedText>
                  </label>
                  <input
                    type="number"
                    placeholder="24"
                    value={newCategory.slaHours}
                    onChange={(e) =>
                      setNewCategory({
                        ...newCategory,
                        slaHours: parseInt(e.target.value),
                      })
                    }
                    className="w-full rounded-lg border border-gray-300 px-4 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                    required
                    min="1"
                    max="720"
                  />
                </div>
                <div>
                  <label className="mb-2 block text-sm font-medium text-gray-700">
                    <TranslatedText>  Responsible Department *</TranslatedText>
                  </label>
                  <select
                    value={newCategory.department}
                    onChange={(e) =>
                      setNewCategory({
                        ...newCategory,
                        department: e.target.value,
                      })
                    }
                    className="w-full rounded-lg border border-gray-300 px-4 py-3 transition-colors duration-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Select department</option>
                    <option value="Water Department">Water Department</option>
                    <option value="PWD">Public Works Department</option>
                    <option value="Electricity Board">Electricity Board</option>
                    <option value="Sanitation Department">
                      Sanitation Department
                    </option>
                    <option value="Transportation">
                      Transportation Department
                    </option>
                  </select>
                </div>
              </div>

              <div className="flex justify-end space-x-3 border-t border-gray-200 pt-4">
                <button
                  type="button"
                  onClick={() => setShowAddCategory(false)}
                  className="rounded-lg border border-gray-300 px-6 py-2 text-gray-700 transition-colors duration-200 hover:bg-gray-50"
                >
                  <TranslatedText>Cancel</TranslatedText>
                </button>
                <button
                  type="submit"
                  className="flex items-center space-x-2 rounded-lg bg-green-600 px-6 py-2 text-white transition-colors duration-200 hover:bg-green-700"
                >
                  <Settings className="h-4 w-4" />
                  <span><TranslatedText>Add Category</TranslatedText></span>
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Categories Table */}
        <div className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-lg">
          <div className="border-b border-gray-100 bg-white px-8 py-6">
            <div className="flex items-center justify-between">
              <h4 className="text-2xl font-bold text-gray-900">
                <TranslatedText>Current Categories</TranslatedText>
              </h4>
              <div className="rounded-lg bg-gray-100 px-4 py-2 text-sm text-gray-500">
                <TranslatedText>Total:{' '}</TranslatedText>
                <span className="font-semibold text-gray-900">
                  {formatNumberForLanguage(categories.length, currentLanguage)}
                </span>{' '}
                <TranslatedText>  categories</TranslatedText>
              </div>
            </div>
          </div>

          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="border-b border-gray-100">
                  <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    SLA Target
                  </th>
                  <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    Department
                  </th>
                  <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    Status
                  </th>
                  <th className="px-8 py-5 text-left text-sm font-semibold uppercase tracking-wide text-gray-700">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {categories.map((category) => (
                  <tr
                    key={category.id}
                    className="border-b border-gray-50 transition-colors hover:bg-gray-50/50"
                  >
                    <td className="px-8 py-6">
                      <div className="flex items-center">
                        <div className="mr-4 flex h-10 w-10 items-center justify-center rounded-full bg-orange-100">
                          <Settings className="h-5 w-5 text-orange-600" />
                        </div>
                        <div>
                          <div className="text-sm font-semibold text-gray-900">
                            <TranslatedText>{category.name}</TranslatedText>
                          </div>
                          <div className="text-sm text-gray-500">
                            <TranslatedText>ID: CAT{category.id.toString().padStart(3, '0')}</TranslatedText>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="px-8 py-6">
                      <div className="flex items-center">
                        <span
                          className={`inline-flex items-center px-3 py-2 text-xs font-semibold rounded-full ${category.slaHours <= 24
                            ? 'bg-green-100 text-green-800'
                            : category.slaHours <= 48
                              ? 'bg-yellow-100 text-yellow-800'
                              : 'bg-red-100 text-red-800'
                            }`}
                        >
                          {formatNumberForLanguage(`${category.slaHours}h`, currentLanguage)}
                        </span>
                      </div>
                    </td>
                    <td className="px-8 py-6">
                      <div className="text-sm text-gray-900">
                        <TranslatedText>{category.department}</TranslatedText>
                      </div>
                    </td>
                    <td className="px-8 py-6">
                      <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-2 text-xs font-semibold text-green-800">
                        <TranslatedText>Active</TranslatedText>
                      </span>
                    </td>
                    <td className="px-8 py-6">
                      <div className="flex items-center space-x-3">
                        <button className="text-blue-600 transition-colors duration-200 hover:text-blue-800">
                          <TranslatedText>Edit</TranslatedText>
                        </button>
                        <button
                          onClick={() => handleDeleteCategory(category.id)}
                          className="text-red-600 transition-colors duration-200 hover:text-red-800"
                        >
                          <TranslatedText>Remove</TranslatedText>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  };

  // Navigation items with icons
  const navigationItems = [
    {
      id: 'dashboard',
      label: 'Analytics Dashboard',
      icon: BarChart3,
      description: 'View System Metrics And Performance',
    },
    {
      id: 'reports',
      label: 'Advanced Reports',
      icon: FileText,
      description: 'Generate Detailed Analytics Reports',
    },
    {
      id: 'officers',
      label: 'Manage Users',
      icon: Users,
      description: 'Add, Edit, and Manage System Users',
    },
    // {
    //   id: 'schedule',
    //   label: 'Scheduler Report',
    //   icon: Users,
    //   description: 'Add, Edit, and Manage System Users',
    // },
    // {id: 'categories', label: 'Manage Categories', icon: Settings, description: 'Configure complaint categories and SLAs' },
    // {id: 'audit', label: 'Audit Trail', icon: Search, description: 'Monitor system activities and compliance' },
    // {id: 'collaboration', label: 'Collaboration Hub', icon: Users, description: 'Team communication and knowledge sharing' }
  ];

  const userRole = (authUser?.role || '').toUpperCase();
  const filteredNavigationItems =
    userRole === 'COLLECTOR'
      ? navigationItems.filter((item) => item.id !== 'officers')
      : navigationItems;


  if (!authUser) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        {t('admin.pleaseLogin')}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {showResetPassword && selectedOfficer && (
        <ResetPassword
          officer={selectedOfficer}
          onClose={() => setShowResetPassword(false)}
        />
      )}
      <DashboardHeader
        user={authUser}
        handleLogout={handleLogout}
        title={t('admin.title')}
      // notificationCount={5}
      />

      {/* Enhanced Professional Navigation */}
      <div className="border-b-2 border-blue-100 bg-white shadow-lg">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="flex justify-center">
            <nav
              className="flex flex-wrap justify-center gap-2 py-2 sm:gap-6"
              aria-label="Admin Navigation"
            >
              {filteredNavigationItems.map((item) => {
                const IconComponent = item.icon;
                const labelKey = `admin.nav.${item.id}.label`;
                const descKey = `admin.nav.${item.id}.description`;
                const label = t(labelKey);
                const description = t(descKey);

                return (
                  <button
                    key={item.id}
                    onClick={() => handleTabSwitch(item.id)}
                    className={`
                      flex items-center space-x-2 py-3 px-4 rounded-lg font-semibold text-sm whitespace-nowrap transition-all duration-300 transform hover:scale-105
                      ${activeTab === item.id
                        ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg border-2 border-blue-500'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-gray-900 border-2 border-transparent hover:border-gray-300'
                      }
                    `}
                    title={description}
                  >
                    <IconComponent
                      className={`w-5 h-5 ${activeTab === item.id ? 'text-white' : 'text-gray-600'}`}
                    />
                    <span className="hidden sm:inline">{label}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
        {/* Page Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div>
              {(() => {
                const activeItem = navigationItems.find(
                  (item) => item.id === activeTab
                );
                const labelKey = activeItem
                  ? `admin.nav.${activeItem.id}.label`
                  : '';
                const descKey = activeItem
                  ? `admin.nav.${activeItem.id}.description`
                  : '';

                return (
                  <>
                    <h2 className="text-2xl font-bold text-gray-900">
                      {activeItem ? t(labelKey) : ''}
                    </h2>
                    <p className="mt-1 text-gray-600">
                      {activeItem ? t(descKey) : ''}
                    </p>
                  </>
                );
              })()}
            </div>

            {/* Quick Actions
            <div className="flex items-center space-x-3">
              <button className="flex items-center space-x-2 rounded-lg border border-gray-300 bg-white px-4 py-2 text-gray-700 transition-colors duration-200 hover:bg-gray-50">
                <FileText className="h-4 w-4" />
                <span>Export</span>
              </button>
              <button className="flex items-center space-x-2 rounded-lg bg-blue-600 px-4 py-2 text-white transition-colors duration-200 hover:bg-blue-700">
                <Settings className="h-4 w-4" />
                <span>Settings</span>
              </button>
            </div> */}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 min-h-[600px]">
          <div className="p-6">
            {activeTab === 'dashboard' && renderDashboardTab()}
            {activeTab === 'officers' && renderOfficersTab()}


            {activeTab === 'categories' && renderCategoriesTab()}
            {activeTab === 'reports' && renderAdvancedReportsTab()}
            {activeTab === 'audit' && renderAuditTab()}
            {activeTab === 'collaboration' && renderCollaborationTab()}
            {activeTab === 'schedule' && renderCollaborationTab()}
            {activeTab === 'schedule' && <ScheduleReportPage />}
          </div>
        </div>


        {/* Global Image Preview Modal (available across tabs) */}
        {showImageModal && selectedImage && (
          <div
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-75 p-4"
            onClick={handleCloseImageModal}
          >
            <div
              className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between border-b border-gray-200 p-4">
                <h3 className="text-lg font-semibold text-gray-900">
                  {selectedImage.filename}
                </h3>
                <div className="flex items-center gap-2">
                  <button
                    onClick={handleDownloadFromModal}
                    className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700"
                  >
                    <Download className="h-4 w-4" />
                    {t('dashboard.modal.download')}
                  </button>
                  <button
                    onClick={handleCloseImageModal}
                    className="rounded-lg p-2 text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
                    aria-label="Close"
                  >
                    <X className="h-5 w-5" />
                  </button>
                </div>
              </div>
              <div className="flex flex-1 items-center justify-center overflow-auto bg-gray-100 p-4">
                <img
                  src={selectedImage.url}
                  alt={selectedImage.filename}
                  className="max-w-full max-h-[calc(90vh-120px)] object-contain rounded-lg"
                  onError={(e) => {
                    e.target.src =
                      'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3EFailed to load image%3C/text%3E%3C/svg%3E';
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminPage;